export default {
  months: {
    jan: 'janvier',
    feb: 'février',
    mar: 'En mars',
    apr: 'avril',
    may: 'En mai',
    jun: 'juin',
    jul: 'En juillet',
    aug: 'août',
    sep: 'septembre',
    oct: 'octobre',
    nov: 'novembre',
    dec: 'décembre',
  },
  all: 'tout',
  day: 'journée',
  one_month: 'un mois',
  three_months: 'trois mois',
  six_months: 'six mois',
  one_year: 'un ans',
  increase: 'augmenter',
  deduction: 'réduire',
  new: 'Nouveau',
  past: 'passé',
  memo: 'Remarque',
  enter_memo: 'Veuillez saisir une note.',
  price: 'Prix',
  enrollment: 'Inscription',
  re_enter: 'Re-entrer',
  registration_complete_txt: "L'inscription est terminée",
  registration_failed_txt: "L'enregistrement a échoué.",
  bank_name: 'Nom de banque',
  locale_name: 'Français',
  sale_registration: 'Inscription vente',
  apply: 'appliquer',
  status: 'status',
  wallet: 'portefeuille',
  buy: 'acheter',
  sell: 'vendre',
  breakdown: 'Ventilation',
  act_buy: 'acheter',
  act_sell: 'vendre',
  asset: 'actif',
  select: 'sélectionner',
  no_select: 'pas de sélection',
  account: 'compte',
  balance: 'équilibre',
  login: 'Connexion',
  logout: 'déconnexion',
  register: 'Joindre en tant que membre',
  select_cancel: 'décocher',
  cancel: 'annuler',
  modify: 'éditer',
  auto_input: '(saisie automatique)',
  confirm: 'confirmer',
  look_up: 'lookup',
  password: 'mot de passe',
  account_delete: 'se désinscrire',
  detail: 'détail',
  list_detail: 'Détails détaillés',
  birth: 'anniversaire',
  welcome: 'Bienvenue',
  please_login: 'Veuillez vous connecter',
  confirmation_login: 'Vous pouvez le vérifier lors de la connexion.',
  id: 'ID',
  find_id: 'find ID',
  find_password: 'trouver le mot de passe',
  back: 'retour',
  agreement: 'accord',
  info_input: 'info d`entrée',
  success: 'complet',
  agree_msg: 'Je suis d`accord',
  all_agree: "Je suis d'accord à tous",
  agree: "Se mettre d'accord",
  confirm_password: 'Confirmez le mot de passe',
  repeat_password: 'Confirmez le mot de passe',
  next: 'Prochain',
  before: 'Retourner',
  register_success: 'Vous êtes inscrit',
  verify: 'vérifier',
  retention: 'rétention',
  allow: '(autoriser)',
  disallow: '(interdit)',
  upload_btn: 'Veuillez déposer ou cliquer ici le fichier.',
  continue_entry:
    'Veuillez saisir "[+:verification]" ci-dessous pour continuer',
  login_msg_1: 'Essayez un compte associé à des pièces sur ONEWORLDPAY !',
  login_msg_2:
    'Veuillez utiliser les transactions, les portefeuilles et les services via notre ONEWORLDPAY.',
  login_msg_3: 'ONEWORLDPAY prend en charge tous les environnements',
  cocofx_register: 'Register ONEWORLDPAY',
  register_msg_1:
    "Inscrivez-vous en tant que membre. <br /> S'il vous plaît accepter nos termes et conditions",
  register_msg_3:
    "Un compte ONEWORLDPAY donnera accès à tous les services à l'aise.",
  register_msg_all:
    "Le consentement à tous comprend le consentement aux éléments obligatoires et facultatifs, et vous pouvez sélectionner le consentement individuellement. Même si vous refusez d'accepter les options, le service est disponible.",
  register_title: "Je suis au-dessus de l'âge de 19 ans et plus.",
  register_title_2: 'Conditions ONEWORLDPAY',
  register_title_3: 'ONEWORLDPAY Conditions de services intégrés',
  register_title_4: 'levier marketing ONEWORLDPAY accord',
  register_title_5:
    "Le consentement à la collecte et l'utilisation des renseignements personnels",
  register_title_6:
    "Consentement à la collecte et l'utilisation d'informations",
  register_title_7:
    "D'accord pour recueillir des informations de profil supplémentaires",
  register_title_8: 'Entrée ONEWORLDPAY Informations sur le compte',
  register_title_9: "Informations d'entrée",
  register_msg_4:
    "Ces conditions sont applicables à tous les services fournis par la société. <br /> En acceptant ces conditions, vous pouvez utiliser ces services sans la signature d'un contrat distinct.",
  required: '[Obligatoire]',
  option: '[Sélectif]',
  otp_notice: "L'état est activé et désactivé OTP impossible.",
  required_check: "S'il vous plaît vérifier tous les champs obligatoires",
  check_input: "S'il vous plaît entrer tous les détails.",
  register_guide: 'Comment utiliser ONEWORLDPAY',
  register_step1: 'Cliquez sur le bouton COCO BANK',
  register_step2: 'Connectez-vous à COCO BANK',
  register_step3: 'Paiement / Recharge COCO BANK Connexion',
  copy: 'copier',
  no_account: "Il n'y a pas de comptes enregistrés.",
  inviter_link: 'liens de référence',
  register_used_account: 'Inscrivez-vous des comptes fréquemment utilisés',
  security_certification: 'Certification de sécurité',
  company: 'entreprise',
  exact_calculation: 'réglage',
  profile: 'Informations membres',
  inquiry: 'enquête',
  announcement: 'notifications',
  information: 'informations',
  history: 'histoire',
  registration_date: "Date d'inscription",
  pay: 'Paiement',
  detail_search: 'Recherche en texte intégral',
  market: 'marché',
  holding: 'en portant',
  fee_charged: 'Frais facturés',
  type_of_charge: 'Type de charge',
  auto: 'Automatique',
  manual: 'Manuel',
  s_usdt_protocol: 'Choisissez un protocole Tether',
  header: {
    c2c_enroll: 'Enregistrement achat / vente',
    wallet_list: 'Recherche de sac à main / historiques',
    wallet: 'portefeuille',
    c2c_list: 'historique des achats / ventes',
    no_c2c_sell_list: "Il n'y a pas l'historique des ventes.",
    transfer_list: 'changement de devise',
    no_transfer_list: "Il n'y a pas d'antécédents d'échange.",
    withdrawal_list: 'Dépôts / retraits',
    my_info: 'mes infos',
    home: 'principal',
    payment_history: 'Historique de facturation',
    account_transfer: 'Transfert de compte',
    transfer_history: 'Historique du transfert',
    register_used_account: 'Inscrivez-vous des comptes fréquemment utilisés',
    exchange: 'pour l échange',
    exchange_store: 'échange',
    exchange_list: 'Histoire de change',
    email: 'E-mail',
    email_list: 'Histoire Email',
    otp: 'OTP',
    otp_list: 'Histoire du Bureau du Procureur',
    register_account: 'compte d enregistrement',
    calculation_account_list: 'Liste des comptes de règlement',
    security_certification: 'Certification de sécurité',
    exact_calculation: 'réglage',
    history: 'histoire',
    coco_open_market: 'COCO Open Market',
    information: 'informations',
    my_profile: 'information My',
    email_modify: 'Modifier e-mail',
    password_modify: 'Modifier votre mot de passe',
    inquiry: 'enquête',
    inquiry_history: 'Détails de contact',
    one_on_one_inquiry: '1:1 enquête',
    frequently_asked_questions: 'FAQ',
    announcement: 'notifications',
    notice: 'notifications',
    server_notice: 'Annonces de serveur',
    service_center: 'Centre de services',
    profile: 'Informations membres',
    company: 'entreprise',
    account_management: 'gestion du compte',
    do_exchange: 'pour l échange',
    transfer: 'transferts',
    look_up: 'référence',
    faq: 'FAQ',
    server: 'serveur',
    email_request: 'E-mail Contactez',
    Balance_transfer_history: 'Détails du solde',
    no_balance_transfer_history:
      "Il n'y a pas d'historique de mouvement d'équilibre du marché.",
    manual: 'Manuel',
  },
  header_sub: {
    exchange_list: 'changement de devise',
    transfer_list: 'Historique du transfert',
  },
  footer: {
    footer_msg: 'Essayez un compte associé à des pièces sur ONEWORLDPAY!',
    footer_sub_msg:
      'Veuillez utiliser les transactions, les portefeuilles et les services via notre ONEWORLDPAY',
    footer_sub_msg2: 'Astuce',
    footer_sub_msg3: 'ONEWORLDPAY prend en charge tous les environnements',
    ICO: 'ICO',
    c2c: 'échange C2C',
    b2c: 'échange B2C',
    margin_exchange: 'échange de marge',
    futures_exchange: 'Bourse à terme',
    Binary: 'options binaires',
    open_marcket: 'marché ouvert',
    game: 'jeu',
    proceed: 'transaction en cours',
    public: 'Listed',
    direct_ex: 'échange de devises direct',
    buy: 'acheter',
    sell: 'vendre',
    buy_sell: 'acheter / vendre',
    holding_coin: 'tenant une pièce',
    fee: 'informations sur la taxe',
    exchange: 'échange',
    transfer_record: 'enregistrement de transaction',
    Leverage: 'effet de levier',
    live_exchange: 'offres en direct',
    demo_exchange: 'accord de démonstration',
    contest: 'concours',
    powerball: 'powerball',
    law:
      "Juridique: numéro d'enregistrement ONEWORLDPAY.COM: 70638826927 (U 6 29 Pde Railway EastwoodNSW 2122)",
    law1:
      "Trading Point d'instruments financiers Le propriétaire de l'ensemble Ltd (Australie) est ONEWORLDPAY PTY Ltd Numéro d'enregistrement: 70638826927 marque.",
    law2:
      'Ce site Web est alimenté par ONEWORLDPAY Corp. ONEWORLDPAY Corp a approuvé le numéro 64190 - sont sous le contrôle du service des finances auxiliaire, il est enregistré dans le numéro de référence 70638826927 Australie.',
    law3:
      "ONEWORLDPAY fonctionne selon les produits financiers australiens directives d'investissement.",
    law4:
      'Réf. pas. 538324 | ABN reg. 70638826927 | BA reg. 64190. Pour vous assurer que vous êtes autorisé à utiliser les services ONEWORLDPAY dans les dispositions légales du pays de résidence est la seule responsabilité du client.',
    law5:
      "S'il vous plaît lire le COCO professionnel Divulgation des risques FX.",
    law6:
      'ONEWORLDPAY ne fournit pas de services aux États-Unis, le Belize, Maurice, Japon, Alberta, Colombie-Britannique, le Québec, la Saskatchewan Les résidents de la Saskatchewan, en Haïti, le Suriname, la Corée du Nord, Porto Rico et la zone occupée de Chypre.',
    law7:
      "S'il vous plaît se référer à la partie réglementaire de la FAQ pour plus d'informations. S'il vous plaît consulter notre information sur les risques.",
    law8:
      "zones d'accès restreint: Trading Point de Financial Instruments Ltd ne fournit pas l'investissement et les services auxiliaires aux pays du tiers monde et régions.",
    law_warn: 'Avertissement de risque:',
    law_1:
      "CFD présente un risque élevé et des produits complexes perdent rapidement leur argent en raison de l'effet de levier. 69,10% des investisseurs individuels compte, il perdra de l'argent lors de la négociation du CFD.",
    law_2:
      "Vous devez vous demander si vous pouvez accepter le fait que vous comprenez le fonctionnement CFD, plus le risque de perdre de l'argent. S'il vous plaît consulter notre information sur les risques.",
    alert_title: 'Note et Note',
    coco_market: 'COCO marché',
    ieo_market: 'IEO marché',
    news: 'Nouvelles',
    event: 'Événement',
    platform_rental_title: 'Location Platform',
    education: 'éducation',
    online_Academy: 'Académie en ligne',
    offline_Academy: 'Académie Hors ligne',
    shopping_basket: 'panier',
    best_product: 'Meilleures affaires',
    order: 'ordre',
    my_page_title: 'ma page',
    member_info_management: 'Gestion de compte',
    order_management: 'La gestion des commandes',
    my_question: 'ma question',
    one_enquiry: '01:01 Contactez',
    community: 'communauté',
    lotto: 'Powerball',
    rock_event: 'rock Event',
    quiz_game: 'Trivia Game',
    ladder_game: 'Échelle',
    tetris: 'Tetris',
    split_lotto: 'divisé Lotto',
    day_Lottery: 'loterie quotidienne',
    attendance: 'vérification de présence',
    scoop_out: 'Intégrer',
    forum: 'forum',
  },
  b2c_exchange: {
    trading_view: 'TradingView',
    basic_chart: 'graphique de base',
    today_hight: 'Prix élevé (même jour)',
    today_row: 'Prix bas (même jour)',
    tightening_strength: 'Force de serrage',
    h24_volume: 'Volume (24H)',
    h24_transaction_amount: 'Montant de la transaction (24H)',
    previous_days_closing_price: 'Cours de clôture du jour précédent',
    auxiliary_indicator: 'Indicateur auxiliaire',
    unlimited_number:
      "Vous pouvez sélectionner un nombre illimité d'indicateurs. ",
    rod_type: 'Type de tige',
    chart_type: 'Type de graphique',
    market_name: 'Nom du marché',
    present_price: 'Prix actuel',
    compared_to_the_previous_day: 'Par rapport à la veille',
    volume: 'Le volume',
    coin_name_and_symbol_search: 'recherche Nom / symbole de la pièce',
    event: 'un événement',
    asking_price_window: 'Fenêtre de devis',
    sell_order: 'Vendre',
    buying_order: 'achat',
    limits: 'limites',
    maximum_order_price_quantity: 'Quantité de prix de commande maximum',
    direct_input: 'Entrée directe',
    order_classification: 'Classement des commandes',
    order_available: 'Commande disponible',
    order_quantity: 'Quantité de commande',
    total_order_amount: 'Montant total de la commande',
    quantity_user_fee_rate: "Quantité Taux de frais d'utilisation",
    quantity_creator_fee_rate: 'Taux des frais de création de quantité',
    reset: 'réinitialiser',
    conclusion_price: 'Prix de conclusion',
    tightening_amount: 'Montant de serrage',
    execution_time: "Temps d'exécution",
    execution_price: "Prix d'exécution",
    execution_quantity: 'Quantité de contrat',
    execution_amount: "Montant de l'exécution",
    order_date_and_time: 'Date et heure de la commande',
    transaction_coin: 'Pièce de transaction',
    order_price: 'Prix de la commande',
    untraded_quantity: 'Quantité non échangée',
    state: 'Etat',
    current_price: 'Prix actuel',
    division: 'division',
    transaction_price: 'Prix de transaction',
    week52_high: '52 semaines maximum',
    week52_minimum: '52 semaines minimum',
    days_closing_price: 'Cours de clôture du jour précédent',
    same_day_high_price: 'Prix élevé le jour même',
    low_price_on_the_day: 'Prix bas le jour',
    average_price: 'Prix moyen',
    cumulative_quantity: 'Quantité cumulée',
    cumulative_amount: 'Montant cumulé',
    selection: 'Sélection',
    minimum_ask_quantity: 'Quantité la plus élevée demandée',
    save: 'sauvegarder',
    accounts_that_can_be_traded:
      "Il n'y a pas de compte disponible pour le trading.",
    won_pay: 'KRW',
    coin_order: 'Commande',
    asking_price: 'Demander un prix',
    chart: 'Graphique',
    quote: 'Citation',
    order_details: 'Détails de la commande',
    account_number: 'Numéro de compte',
    moving_quantity: 'Quantité en mouvement',
    registration_date: "Date d'inscription",
  },

  main_msg: {
    about_1_title: 'Le meilleur service de trading de crypto-monnaie au monde',
    about_1_msg: 'ONEWORLDPAYdirige tous les services liés aux pièces.',
    about_1_1_msg:
      'Vous pouvez acheter et vendre des pièces de crypto-monnaie au même endroit pour la première fois dans le monde.',
    about_1_2_msg:
      "En ce qui concerne l'échange direct, il est disponible à ONEWORLDPAY.",
    about_2_title: 'Système d`échange instantané',
    about_2_msg:
      'ONEWORLDPAY utilise une technologie stable de mise en parallèle multiple Technologie de conception avancée pour permettre un échange instantané J`ai un système de change de devises',
    about_3_title: 'Créer un portefeuille',
    about_3_msg:
      'ONEWORLDPAY est composé des meilleurs experts en sécurité en Corée Fournit un système WALLET avec un système de sécurité avancé.',
    about_4_title: 'Easy Trading System (C2C)',
    about_4_msg:
      ' ONEWORLDPAY construit un système de trading simple et convivial Facilitons les transactions.',
    c2c_main_msg1_1:
      "ONEWORLDPAY échangera immédiatement en utilisant la technologie d'appariement multi-parallèle fiable",
    c2c_main_msg1_2:
      "Tenir le système d'échange, en appliquant les techniques de conception avancées pour activer et",
    c2c_main_msg1_3: 'Il y a.',
    c2c_main_msg2_1:
      'Les experts en sécurité ont été ONEWORLDPAY est composé des meilleurs ingénieurs en Corée',
    c2c_main_msg2_2:
      "Equipé d'un système de sécurité l'état de l'art fournit système de portefeuille.",
    c2c_main_msg3_1:
      'ONEWORLDPAY est plus facile à construire le système commercial convivial',
    c2c_main_msg3_2: 'Il permet la négociation facile.',
  },
  toasted_msg: {
    confirm: 'confirmé',
    changed: 'changé',
    withdrawal: 'désactivé',
    register: 'enregistré',
    delete: 'Il a été supprimé.',
    title: 'Notifications',
    exchange: 'La devise directe a été traitée avec succès.',
    search: 'vu',
    deposit_request: 'Votre demande de dépôt',
    withdraw_request: 'Retrait demandé',
    create_account: 'Ouvert',
    modify: 'modifié',
    cancel: 'Annulé',
    trade_confirm: 'La transaction a été confirmée.',
    trade_reject: 'Commerce refusé.',
    copy: 'copié',
    nice_msg:
      'Si les paramètres de votre navigateur n`autorisent pas les fenêtres contextuelles, la vérification d`identité ne se déroulera pas normalement.',
    nice_title: 'guide',
    nice_success: 'Votre authentification a réussi.',
    nice_error: 'Je ne peux pas m`authentifier.',
    no_transfer: 'Pas d`échange d`informations',
    email_auth: 'L`authentification par e-mail s`est terminée avec succès',
    email_auth_send: 'Un email d`authentification a été envoyé',
    kyc_withdraw: 'La vérification du compte a réussi',
    not_allow_trade: 'Commerce inactif',
    id_find_mail_send: 'Votre e-mail a été envoyé.',
    duplicate_check: 'ID en double ou par courriel.',
    pay: 'Le paiement est terminé.',
    msg_holding: 'Il a eu lieu.',
    msg_read_care: "Note Avez-vous lu et compris l'information?",
    answer_care: 'Je connaissais quatre',
    continuation: 'continuer',
    continue_entry:
      'S`il vous plaît entrer votre: "[+:verification]" Pour continuer ci-dessous.',
  },
  private: {
    market_name: 'Nom du marché',
    deal_list: 'Historique des ventes',
    app_list: 'Historique des achats',
    app_detail: 'achats Détail',
    deal_buy_asset: 'actifs à acheter',
    buy_price: 'prix d`achat',
    confirmed_source_amount: 'Quantité de vente confirmées',
    holding_source_amount: 'Quantité de vente non engagée',
    potential_source_amount: 'quantité disponible',
    direct_market: 'échange de devises direct',
    deal_enroll: 'enregistrement des ventes',
    app_enroll: 'enregistrement d`achat',
    select_market: 'market select',
    fee_rate: 'taux de redevance',
    free: 'libre',
    deal_info_input: 'saisir les informations de vente',
    deal_source_amount: 'quantité de vente',
    deal_price: 'prix de vente par pièce',
    deal_enroll_account: 'Enregistrement du compte pour la vente',
    account_select: 'sélectionner le compte',
    direct_asset_select: 'Veuillez sélectionner un actif à vendre et à acheter',
    please_select_asset: 'Veuillez sélectionner un élément.',
    basic_rate: 'prix actuel',
    direct_transfer_buy: 'à l`achat immédiatement',
    direct_transfer_sell: 'en vente immédiatement',
    direct_source_amount: 'quantité d`échange',
    direct_target_amount: 'quantité appliquée',
    direct_asset_buy: 'acheter avec {0}',
    direct_asset_sell: 'vendre comme {0}',
    selected_deal_info: 'Informations de vente sélectionnées',
    deal_source_asset_title: 'acheter un bien',
    deal_total_source_amount: 'Quantité totale des ventes',
    app_info_input: 'saisir les informations d`achat',
    app_amount: 'quantité d`achat',
    app_deal_price: 'prix unitaire',
    pay_target_amount: 'quantité à payer',
    fee: 'redevances',
    fee_calc: 'montant des frais',
    msg_fee_calc: 'Déduit de {0}',
    app_account: 'Compte pour l`enregistrement d`achat',
    app_receive_account: 'Choisissez le compte à recevoir',
    c2c_buy_select_asset:
      "S'il vous plaît sélectionner la divulgation de vente être achetés à la principale",
    go_home: 'retourner au principal',
    buy_calc_spread: 'taux de change d`achat',
    sell_calc_spread: 'le taux de vente',
    cs_market_asset: 'paire d`actifs',
    cs_market_basic_rate: 'Taux de vente de base',
    transfer_type: 'type de devise',
    exchange_rate: 'taux de change appliqué',
    submit_transfer: 'échange immédiat',
    deal_source_min_amount: 'Quantité minimale d`achat',
    closed_date: 'date de fermeture',
    no_deal: 'Pas de liste de vente',
    app_price_per_quantity: 'prix par quantité',
    app_fee_amount: 'Sum total',
    select_deal_app_list: 'Achats pour certaines ventes',
    no_select_deal_app_list: 'Aucun historique d`achat pour cette vente',
    transfer_source_amount: 'quantité d`actif de référence',
    transfer_target_amount: 'quantité d`actif relative',
    transfer_basic_rate: 'Taux d`application',
    transfer_spread_rate: 'Appliquer le taux de propagation',
    transfer_exchange_rate: 'taux d`application',
    transfer_list_detail: 'Détails des détails de la demande d`échange',
    transfer_source_asset: 'actif de référence',
    transfer_target_asset: 'actif relatif',
    transfer_source_account_number: 'Numéro de compte d`actif de base',
    transfer_target_account_number: 'Numéro de compte d`actif relatif',
    transfer_detail_type: 'type de transfert',
    transfer_regdate: 'date d`application',
    transfer_asset_info: '{0} à {1} {2}',
    transfer_asset_select: 'Veuillez sélectionner un élément à remplacer.',
    msg_transfer_buy: 'acheter avec {0}',
    msg_transfer_sell: 'Vendre en tant que {0}',
    deal_fee_amount: 'frais imposés vente partie Disclosure',
  },
  wallet_page: {
    total_amount: 'montant total',
    have_asset: 'détention d`actifs',
    asset_list: 'liste d`actifs',
    account_list: 'liste de comptes',
    account_create: 'créer un compte',
    deposit: 'caution',
    withdraw: 'retrait',
    deposit_list_look: 'Afficher l`historique des dépôts',
    deposit_look: 'recherche de dépôt',
    withdraw_list_look: 'recherche de l`historique des retraits',
    withdraw_look: 'recherche de retrait',
    account_modify: 'modifier le compte',
    deposit_apply: 'demander un dépôt',
    withdraw_apply: 'retrait',
    deposit_request_amount: 'le montant du dépôt',
    withdraw_request_amount: 'montant du retrait',
    withdraw_account_info: 'informations de compte de retrait',
    holder_name: 'le nom du titulaire',
    bank_name: 'bank name',
    withdraw_bank_address: 'numéro de compte',
    withdraw_address: 'adresse de l`actif',
    qr_address: 'adresse de compte',
    create_qr_address: 'Ouvrir une adresse de compte',
    account_enroll: 'Enregistrement de compte',
    account_seq: 'numéro unique de compte',
    account_title: 'nom du compte',
    account_msg: 'Veuillez entrer votre nom de compte pour changer.',
    regdate: 'date d`ouverture',
    before_regdate: '(avant ouverture)',
    holding_balance: 'hold amount',
    select_asset: 'sélectionner les actifs',
    create: 'ouvert',
    deposit_list: 'Historique des dépôts',
    no_deposit_list: "Il n'y a pas de détails sur la demande de dépôt.",
    deposit_apply_detail: 'Détails détaillés du dépôt',
    asset_title: 'asset name',
    request_amount: 'request amount',
    withdraw_list: 'historique des retraits',
    no_withdraw_list: "Il n'y a pas de demande de retrait.",
    withdraw_apply_detail: 'Détails détaillés de la demande',
    withdraw_fee_total_amount: 'Retrait total (y compris les frais)',
    net_amount: 'montant final',
    fee_type: 'type de taxe',
    create_account_address: "Compte Adresse d'ouverture",
    deposit_msg:
      "Déposer mon porte-monnaie {0} {0} de l'extérieur du porte-monnaie.",
    deposit_msg_1:
      'Une fois approuvés 350 fois (confirmation) sur la chaîne de bloc {0} transactions sont reflétées dans le portefeuille.',
    deposit_step_1: "ÉTAPE 1. Vérifiez l'ID {0} notes de service en premier.",
    deposit_step_1_1: 'Mes notes ID {0}',
    deposit_step_1_2:
      '{0} doit marquer vos propres notes ID lorsque vous déposez. {0}, sans notes de transfert ID est perdu.',
    deposit_step_1_3: 'Voir votre {0} Adresse Wallet.',
    deposit_step_1_btn: 'Remarques ID Copy',
    deposit_step_2: 'ÉTAPE 2. Vérifiez votre adresse de portefeuille.',
    deposit_step_2_1: 'QR code',
    deposit_step_2_2: 'Adresse Wallet',
    deposit_step_2_3:
      'Le montant du dépôt minimum est de <span style = "color: # 4a90e2"> {0} {1} est </ span>.',
    deposit_step_2_btn: "Porte-monnaie Copier l'adresse",
    deposit_msg_2: "S'il vous plaît vérifier",
    deposit_msg_2_1: "Cette adresse est l'adresse de dépôt seulement.",
    deposit_msg_2_2:
      'Le temps total qu\'il faut pour se conformer fin peut être affectée par la congestion du réseau de la chaîne de blocs, crypto-monnaie stars Block Chaining la congestion est <span style ="color: #4a90e2; cursor: pointer;"> ici </span> vous pouvez vérifier.',
    no_account_list: "Il n'y a pas de liste de comptes.",
    no_favorite_account_list: "Il n'y a pas de liste de comptes favoris.",
    enter_wallet_adress: "Saisissez l'adresse du portefeuille",
  },
  my_page: {
    my_profile: 'information My',
    user_name: 'nom d`utilisateur',
    email_address: 'email',
    register_regdate: 'date d`abonnement',
    last_login: 'dernière connexion',
    auth_complete: 'authentification terminée',
    not_auth: 'Non certifié',
    expdate: 'date d`expiration',
    act_auth: 'authentifier',
    realname_auth: 'authentification de personne',
    email_auth: 'authentification e-mail',
    otp_auth: 'Authentification OTP',
    enroll: 's`inscrire',
    security: 'niveau de sécurité',
    show_security: 'Afficher le niveau de sécurité',
    auth_withdraw_address: 'authentification de l`adresse de retrait',
    apply_list: 'historique des applications',
    password_modify: 'modifier le mot de passe',
    email_modify: 'modifier l`email',
    account_block: 'Quitter le compte',
    placeholder_old_password: 'Veuillez saisir votre mot de passe existant',
    placeholder_new_password: 'Veuillez saisir un nouveau mot de passe',
    placeholder_confirm: 'Veuillez saisir une nouvelle fois',
    placeholder_password: 'Veuillez saisir votre mot de passe',
    placeholder_email: 'Veuillez saisir un nouvel e-mail',
    mail_cert_list: 'application Email Histoire',
    no_mail_list: "Pas d'historique application de messagerie.",
  },
  kyc: {
    str_birth: 'date de naissance',
    enter_adress: "Veuillez saisir l'adresse de atouts",
    register_account: 'compte d enregistrement',
    kyc_enroll: 'Demander la certification KYC',
    auth: 'authentification',
    auth_code_send: 'envoyer le code de vérification',
    auth_code: 'code d`authentification',
    msg_auth_code:
      'Veuillez saisir votre code de vérification dans les 5 minutes',
    type_title: 'type name',
    withdraw_auth: 'authentifier l`adresse de retrait',
    select_asset: 'sélectionner les actifs',
    select_bank: 'sélectionner la banque',
    holder_name: 'le nom du titulaire',
    birth: '6 chiffres de naissance',
    address: 'adresse de l`actif',
    withdraw_list: 'demande de compte de retrait',
    bank_name: 'bank name',
    withdraw_info: 'informations sur le compte de retraits',
    withdraw_complete: 'L`actif est déjà vérifié.',
    regdate: 'date d`enregistrement',
    delete_withdraw_address: 'Adresse de débit modifié',
    delete_success_address: "L'adresse de retrait a changé.",
    kyc_cert_list: 'KYC Historique de la demande',
    no_kyc_list: "KYC est pas d'antécédents d'application.",
    no_kyc_withdraw_address_list:
      "Il n'y a pas d'antécédents d'ouverture de compte de paiement.",
  },
  otp: {
    enter_verification_number: 'Entrez votre numéro de vérification OTP',
    otp_auth: 'Authentification OTP',
    authenticode: 'clé OTP',
    otp_deactivate: 'OTP désactiver',
    msg_authenticator_installation:
      'Veuillez installer l`application" Google Authenticator "sur votre smartphone ou votre ordinateur"',
    android: 'android ',
    or: 'ou',
    iphone_series: 'iPhone，iPad et iPod',
    windows_phone: ' Windows Phone',
    and: ', et',
    msg_microsoft_other_systems:
      'Autres systèmes, y compris le bureau Microsoft Windows',
    msg_key: 'cette clé',
    msg_use_loss_change:
      ' Écrire sur papier Utilisé lorsque vous perdez votre appareil ou devez changer votre OTP.',
    msg_brcode_touch:
      'Exécutez l`application" Google Authenticator "et appuyez sur <b> Scanner le code-barres QR </ b> en bas de l`écran.',
    msg_input_authenticode:
      'Veuillez saisir le code de vérification affiché sur l`écran du terminal dans le champ` Code d`authentification `ci-dessous.',
    otp_key: 'Clé OTP',
    otp_activate: 'OTP activate',
    otp_copy: 'Clé OTP copiée',
    otp_safe_keeping:
      'Avez-vous écrit la clé OTP sur du papier et l`avez-vous stockée en lieu sûr?',
    yes: 'oui',
    otp_register: 's`inscrire',
    otp_register_success: 'L`eregistrement OTP s`est terminé avec succès',
    otp_delete_success:
      'L`enregistrement d`effacement OTP s`est terminé avec succès.',
    msg_click_key_copy: 'Cliquez pour copier la clé',
    otp_login: 'Connexion OTP',
  },
  security: {
    show_security: 'Afficher le niveau de sécurité',
    grade: 'grade',
    condition: 'condition',
    restriction: 'restrictions',
    no_grade: 'non classé',
    no: 'aucun',
    security_title: 'Contraintes par condition de sécurité',
    banner1: 'sécurité de confiance',
    banner2:
      "Pour l'achat ou la vente par ONEWORLDPAY, ONEWORLDPAY doit assurer le chiffrement des données, la surveillance des transactions en temps réel, l'acheteur et la politique de protection du vendeur, et tous vos paiements par le biais d'un paiement sécurisé et régime de paiement ONEWORLDPAY reçu.",
    banner_invite: 'ONEWORLDPAY Ne pas avoir un compte?',
    banner_join: 'Inscription gratuite',
    banner3: 'Comment ONEWORLDPAY garde nos clients en toute sécurité',
    content1_h3: 'Acheteur de protection',
    content1_text:
      "En cas d'usure ou de dommages mibaesong de l'acheteur, ONEWORLDPAY peut compenser le montant total des paiements, y compris les frais d'expédition pour les transactions admissibles. *",
    content2_h3: 'Le vendeur',
    content2_text:
      'Si vous recevez un paiement non autorisé ou réclamations mibaesong contre le vendeur dans la vente êtes admissible, vous pouvez obtenir le montant de la protection. *',
    content3_h3: 'Le chiffrement des données',
    content3_text:
      'TLS, les connexions HTTPS pour aider à garder le paiement, la clé épinglant des applications mobiles, la conformité PCI plus sûr.',
    content3_btn: 'conformité PCI',
    content4_h3: 'prévention de la fraude',
    content4_text:
      'Toutes les transactions sont contrôlées en temps réel en analysant votre compte et de soutien pour prévenir les activités frauduleuses et la facturation.',
    sec_h2: 'vérifier Achetez',
    sec_text:
      "ONEWORLDPAY parce que la surveillance des transactions 24 heures par jour, 365 jours quand il détecte quelque chose de différent de d'habitude de contacter l'acheteur vous demande de confirmer votre connexion ou l'achat. Vérifie également ONEWORLDPAY pour tous les achats et les ventes par e-mail.",
    wran_h2: 'Si vous trouvez un des points suspects',
    warn_step1: 'Rapport.',
    warn_step1_text1:
      "Après avoir confirmé les détails n'ont pas trouvé un accord approuvé",
    warn_step1_text2: "Signaler un problème> Rapport d'activité non autorisée",
    warn_step1_text3: 'Cliquez ou contacter immédiatement ONEWORLDPAY.',
    warn_step2: "Vérifiez s'il y a d'autres problèmes.",
    warn_step2_text1:
      "Passez en revue les activités récentes de négociation et les paramètres du compte pour vous assurer que les frais supplémentaires ou des changements, s'il vous plaît signaler également ces informations.",
    warn_step3: "S'il vous plaît changer votre mot de passe.",
    warn_step3_text1:
      'Vous pouvez dans les paramètres du compte dans le menu Sécurité. Ou, si vous ne parvenez pas à vous connecter à votre compte',
    warn_step3_text2: 'Connexion> exploitation forestière Problèmes',
    warn_step3_text3: 'Cliquez ici pour obtenir réinitialisation.',
    warn_btn: 'Rapport de transactions non autorisées',
    online_h2: 'supports ONEWORLDPAY sécurisé activités en ligne.',
    online_h3: 'sécurité des comptes',
    online_text:
      'Protégez votre compte avec un mot de passe hautement sécurisé.',
    online_btn: 'En savoir plus',
  },
  input: {
    id: "ID d'entrée",
    password:
      "un mot de passe d'entrée (8-32 chiffres comportant des caractères spéciaux)",
    repeat_password: 'Confirmez le mot de passe',
    user_name: "Nom d'utilisateur entrée",
    email_address: 'Adresse e-mail entrée',
  },
  oauth: {
    contact_msg:
      'Je veux accès aux informations suivantes dans l`application {0}.',
    agree_msg:
      '{0} Acceptez-vous que l`accès à {1} Les informations personnelles?',
    agree_info:
      'Les informations fournies seront utilisées / stockées pendant une période de service pour l`identification de l`utilisateur, les statistiques, les comptes liés CS et similaires. Informations de base et de fournir les éléments nécessaires sont les informations qui doivent être fournies à utiliser les services de ONEWORLDPAY.',
    agree_request: 'offres',
    agree_msg2:
      'Une fois accepté, les informations seront gérées conformément aux Termes et Conditions et Politique de confidentialité du service.',
    agree: 'Se mettre d`accord',
  },
  pay_head_foot: {
    account_management: 'Gestion de compte',
    settlement_account_list: 'Liste des comptes de règlement',
    account_summary_views: 'Résumé de la recherche de compte',
    fund: 'fonds',
    history: 'Historique de facturation',
    help: 'Aide',
    qa: 'Contactez-nous',
    fee: 'commission',
    secure: 'sécurité',
    go_shop: 'shopping',
    my_info: 'mon profil',
    my_page: 'Paramètres de compte',
    out: 'deconnexion',
    in: 'login',
    about: 'A PROPOS',
    blog: 'Les blogs',
    employ: "Offres d'emploi",
    site_map: 'Plan du site',
    developer: 'promoteur',
    partner: 'partenaire',
    privacy_state: 'Politique de confidentialité',
    usage: "Conditions d'utilisation",
    feed_back: "retour d'information",
    warn_to_consumer:
      "Avis aux clients: les propriétaires de moyens de paiement prépayés ONEWORLDPAY ⓒ ONEWORLDPAY All rights reserved ne nécessite pas l'approbation de l'Autorité de surveillance financière australienne. S'il vous plaît lire attentivement les termes et conditions.",
  },
  continue: 'suite',
  pay_home: {
    cocobank_title: 'COCO Bank',
    platform: 'plate-forme',
    platform_rental: 'location des plates-formes',
    cocopay_is: "ONEWORLDPAY est la croissance de l'entreprise",
    help: 'Aider.',
    home_banner_1:
      'Élargir la base de clients potentiels à travers le monde, et de faciliter la gestion des paiements,',
    home_banner_2:
      "Vendeur d'affaires Protection * et permettre de magasiner en toute sécurité avec surveillance 24/7 de la fraude.",
    home_banner_3: 'Vous pouvez réussir plus facilement.',
    home_banner_warn:
      "* Modalités et conditions applicables au vendeur de protection. S'il vous plaît se référer à votre contrat pour plus de détails sur l'admissibilité.",
    home_banner_join: 'Inscrivez-vous gratuitement.',
    home_sec1_openShop: 'Vous pouvez ouvrir un magasin à ONEWORLDPAY.',
    home_sec1_btn: 'pour faire face',
    home_sec2_h2: 'Obtenez le mode de paiement souhaité.',
    home_sec2_text1:
      'ONEWORLDPAY peut également recevoir des paiements en ligne, mobiles, et même par courriel.',
    home_sec2_text2:
      'Que ce soit le ONEWORLDPAY vendu partout qui peut aider avec le paiement plus facile et plus sûr.',
    home_sec2_online_pay: 'Paiement en ligne',
    home_sec2_online_text:
      'boutons de paiement pour jeu facile disponibles ONEWORLDPAY est très pratique lors de la réception des paiements en espèces et des paiements périodiques, dons, etc. Avec ONEWORLDPAY Checkout, les clients peuvent effectuer des paiements plus rapidement et facilement.',
    home_sec2_online_more: 'Voir plus sur le paiement en ligne',
    home_sec2_voice_invoice: 'Facture Email',
    home_sec2_voice_text:
      'Facile demande par e-mail pour le paiement à la facture libre professionnelle. Les clients étrangers ainsi que sont à la disposition des clients qui ne sont pas compte ONEWORLDPAY.',
    home_sec2_voice_more: 'Voir plus sur les factures par e-mail',
    home_sec2_exchange_pay: "Effectuer un paiement sur l'échange",
    home_sec2_exchange_text:
      "Avec le service de portefeuille intégré sur la bourse, vous pouvez recharger et acheter et vendre des pièces sur n'importe quel échange d'entreprises partenaires.取引所で統合財布サービスを利用して、パートナーのいくつかの取引所でもコインを充電し、購入の販売を利用することができます。",
    home_sec2_exchange_more: "En savoir plus sur la charge d'échange",
    home_sec2_mobile_pay: 'Obtenez les paiements mobiles',
    home_sec2_mobile_text:
      'Des solutions sont automatiquement optimisés pour les mobiles. Obtenez monde où encore plus facile à payer par le site mobile ou les applications Android et iOS.',
    home_sec2_mobile_more: 'Voir plus sur les paiements mobiles',
    home_sec3_h2:
      'Trouver plus de travail avec des partenaires indépendants de ONEWORLDPAY.',
    home_sec3_global:
      'ONEWORLDPAY reliera les opportunités plus globales avec les meilleurs sites indépendants du monde.',
    home_sec3_btn: 'Vérification ONEWORLDPAY freelance',
    home_sec4_h2: 'Il est facile de commencer.',
    home_sec4_banner1:
      'Apprenez tout ce que vous devez commencer par le centre des affaires de ONEWORLDPAY.',
    home_sec4_banner2:
      "Joignez-vous au compte de l'entreprise et de vérifier votre adresse e-mail",
    home_sec4_banner3: 'Certifié au compte bancaire',
    home_sec4_banner4: 'Sélectionnez une solution de paiement',
    home_sec5_h2:
      'Pourquoi le monde de nombreux opérateurs font ONEWORLDPAY de confiance.',
    home_sec5_sub_text:
      "Parce qu'il est un excellent choix. ONEWORLDPAY vous connecter au vendeur 25 appels au client au moins deux cent millions de personnes dans plus de 200 marchés dans le monde entier.",
    home_sec5_h3: 'Sécurité.',
    home_sec5_h3_sub1:
      "détermination automatique escroquerie, opérations de surveillance 24 heures et le vendeur et l'acheteur programme de protection pour protéger votre entreprise et vos clients.",
    home_sec5_h3_more: 'Voir plus sur le paiement en ligne',
    home_sec5_h31: 'Le monde utilise.',
    home_sec5_h31_sub1:
      "Partout dans le monde sans qu'il soit nécessaire d'entrer les informations à chaque fois que vous effectuez un paiement rapidement. Dans 203 marchés dans 26 devises, vous pouvez payer par carte de crédit, carte de débit ou ONEWORLDPAY.",
    home_sec5_h31_more: 'Voir plus sur les factures par e-mail',
    home_sec5_h32: 'Rapide.',
    home_sec5_h32_sub1:
      'Dans la plupart des cas où un paiement de client est immédiatement crédité sur votre compte ONEWORLDPAY. banque ou un paiement débitées au vendeur ou à utiliser librement dans un lieu où le paiement de ONEWORLDPAY possible.',
    home_sec5_h32_more: 'Voir plus sur la vente eBay',
    home_sec6_h2: 'structure tarifaire simple',
    home_sec6_sub:
      "ONEWORLDPAY facturera des frais que lorsque les ventes effectuées. frais ONEWORLDPAY sont fixés en fonction de l'emplacement du client et le montant des ventes.",
    home_sec6_more: 'Voir plus sur les frais',
    home_sec7_h2: 'Communauté pour la Corée du Sud vente, CBT LAB',
    home_sec7_text1:
      "Institut du commerce transfrontalier (TCC LAB) est une communauté marchande Corée ONEWORLDPAY (ONEWORLDPAY Corée) parrainé pour le commerce électronique d'outre-mer a permis.",
    home_sec7_text2:
      "CBT LAB aide l'entreprise East Coast grandir partagent l'information au niveau mondial, comme les dernières tendances, des conseils et des meilleures pratiques.",
    home_sec7_more: 'Apprenez à tirer profit de la TCC LAB',
    home_sec8_h2: 'Rencontrer les partenaires de verrouillage ONEWORLDPAY.',
    home_sec8_text1:
      "Besoin d'aide professionnelle pour votre entreprise en ligne?",
    home_sec8_text2:
      "solutions d'hébergement Web, panier, solutions de commerce électronique, telles que des œuvres d'avance ONEWORLDPAY un partenaire acheté cette aide votre entreprise.",
    home_sec8_text3:
      'Trouver un partenaire ONEWORLDPAY pour mon entreprise en ce moment.',
    home_sec8_more: 'plus de partenaires',
    home_sec9_h2: 'Devenir un vendeur global. Cela ONEWORLDPAY ensemble.',
    home_sec9_btn: 'Créez un compte maintenant',
    home_learn_h2: 'En savoir plus',
    home_learn_li1: 'Solution de paiement Web',
    home_learn_li1_1: 'Paiements sur site marchand',
    home_learn_li1_2: 'ONEWORLDPAY Commander',
    home_learn_li1_3: 'Acheter sur eBay',
    home_learn_li1_4: 'Solutions Comparez',
    home_learn_li2: 'autres paiements',
    home_learn_li2_1: 'ONEWORLDPAY factures e-mail',
    home_learn_li2_2: 'mobile Commerce',
    home_learn_li2_3: 'Affaires pour les paiements automatiques',
    home_learn_li2_4: 'ONEWORLDPAY pour B2B',
    home_learn_li2_5: 'ONEWORLDPAY freelance',
    home_learn_li3: "l'installation et l'intégration ONEWORLDPAY",
    home_learn_li3_1: "centre d'affaires ONEWORLDPAY",
    home_learn_li3_2: 'ONEWORLDPAY Corée communauté marchande (TCC LAB)',
    home_learn_li3_3: 'Ajouter ONEWORLDPAY ONEWORLDPAY sur le site',
    home_learn_li3_4: 'Consultez le meilleur Set Guide',
    home_learn_li3_5: 'promoteur',
    home_learn_li3_6: 'partenaire',
    home_learn_li3_7: 'Comment ONEWORLDPAY',
    home_learn_li4: 'Gérer mon compte',
    home_learn_li4_1: "des applications d'affaires ONEWORLDPAY",
    home_learn_li4_2: "Paramètres de compte d'entreprise",
    home_learn_li4_3: 'Vendeur Programme de protection',
    home_learn_li4_4: 'Gérer les plaintes des clients',
    home_learn_li4_5: 'Comprendre rétrofacturation (rétrofacturation)',
    home_learn_li4_6: 'Comprendre les restrictions de compte',
    home_learn_li4_7: 'Conseils Prévention de la fraude',
    home_learn_li4_8: 'conformité PCI',
  },
  pay_nav: {
    view_your_account: 'Afficher lintégralité de votre compte',
    account_summary_views: 'Résumé de la recherche de compte',
  },
  pay_login: {
    secure_sub_title: 'Connexion et sécurité',
    secure_my_profile: 'mon profil',
    secure_update_complete:
      'Le profil environnemental et les paramètres ont été mis à jour.',
    secrue_suggest: 'Chaque fois que vous nous raconter votre expérience.',
    search: 'récupération',
    my_info: 'Informations personnelles',
    update: 'mettre à jour',
    e_mail: 'E-mail',
    default: 'informations de base',
    call: 'téléphone',
    phone: '(Mobile)',
    pay_mobile: 'Le paiement mobile',
    trading: 'Concessions mutuelles',
    password: 'mot de passe',
    change: 'changement',
    secure_qa: 'question de sécurité',
    staying: 'Rester connecté pour les achats plus rapides',
    edit: 'compilation',
    browse_manage:
      "Gérer le périphérique sélectionné et le navigateur pour maintenir l'état de connexion.",
    account_type: 'Types de compte',
    account_delete: "compte d'annulation",
    business: 'affaires',
    edit_email: "Modifier l'adresse e-mail",
    change_email: "Modifier l'adresse e-mail",
    update_email: 'Ajouter votre e-mail',
    eamil_url: 'Adresse e-mail',
    update_email_url: 'Ajoutez votre adresse e-mail',
    error_email: "Désolé. L'e-mail par défaut ne peut pas être modifié.",
    confirm_new_email: 'Vérifiez la nouvelle adresse e-mail',
    change_mail: 'Modifier e-mail',
    confirm: 'confirmation',
    changing: 'changement',
    deleting: 'effacement',
    reaming:
      "Il existe actuellement deux de l'adresse e-mail associée à votre compte. Vous pouvez ajouter plus de 5 email.",
    qa_1: 'Quel est le nom de la première école?',
    qa_2: 'Quel est le nom du premier animal de compagnie?',
    edit_phone: 'Modifier un numéro de téléphone existant',
    korea: 'République de Corée',
    explanation:
      "En ajoutant le numéro, je confirme que vous êtes d'accord pour composer automatiquement et de recevoir des appels pré-enregistrés et le texte en fonction de la raison de l'autorisation d'ajouter deux numéros sont décrits dans la Politique de confidentialité. Les taux peuvent s'appliquer.",
    edit_phone_num: 'Modifier le numéro de téléphone',
    edit_password: 'Changer mot de passe',
    confirm_password: 'Vérifiez votre mot de passe actuel',
    new_passod: 'nouveau mot de passe',
    confirm_password_new: 'Confirmer le nouveau mot de passe',
    secure_question: 'question de sécurité',
    secure_pick: 'questions à choix',
    secure_answer: 'réponse',
    edit_browse:
      'Avec ONEWORLDPAY One Touch, vous pouvez rapidement effectuer le paiement sans avoir à se connecter à chaque fois.',
    already_log: "L'utilisateur connecté sur la machine.",
    off_all: 'ONEWORLDPAY One Touch sur tous vos appareils',
    support:
      'PayPal est engagé à 100% la satisfaction des clients. Si vous avez un problème avec votre compte',
    support_center: 'Soutien à la clientèle',
    support_text1: 'Ou consultez la',
    support_text2: "S'il vous plaît se référer.",
    support_warn:
      'Si vous annulez votre compte, vous ne pouvez pas annuler vos relevés de compte seront également disparaître et des niveaux de fiabilité.',
  },
  help: {
    support_center: 'soutien',
    resolution_center: 'Résolution des différends Centre',
    qa_search: 'Rechercher Foire aux questions',
    common_qa: 'Questions générales',
    common_qa_1:
      "Qu'est-ce `Pourquoi un message d'erreur est affiché après la mise à jour de l'état de votre commande via les « obtenir des fonds Liens?",
    common_qa_2:
      'Comment puis-je retirer des fonds du compte Corée du ONEWORLDPAY?',
    common_qa_3:
      'Comment puis-je ajouter une carte de débit ou de crédit à mon compte ONEWORLDPAY?',
    common_qa_4:
      "ONEWORLDPAY J'ai oublié mon mot de passe. Comment puis-je réinitialiser mon mot de passe?",
    common_qa_5: 'Puis-je annuler déjà envoyé montant le paiement ONEWORLDPAY?',
    common_qa_6: 'Comment puis-je recevoir des paiements via ONEWORLDPAY?',
    common_qa_7: 'Comment puis-je envoyer le paiement via ONEWORLDPAY?',
    common_qa_8:
      'Comment puis-je ajouter un compte bancaire au compte ONEWORLDPAY?',
    common_qa_9:
      'Comment puis-je vérifier le compte bancaire associé à mon compte ONEWORLDPAY?',
    common_qa_10: 'Comment puis-je désactiver le compte limite de ONEWORLDPAY?',
    technical_support: 'Abonnez-vous aux questions techniques et mises à jour.',
    condition_cocopay: "Afficher l'état ONEWORLDPAY",
    muliple_help: "D'autres façons d'obtenir de l'aide",
    trading_help: 'Pour résoudre beaucoup tels problèmes',
    tex_center: 'Centre fiscal',
    tex_help: "Trouvez les formulaires d'impôt et d'autres ressources",
    need_help: 'Contactez-nous',
    help_center: "Contacter l'assistance à la clientèle",
    help_to_center: "Contacter l'assistance à la clientèle",
    prepare: 'Bientôt.',
    fast_help:
      "Racontez-nous votre problème afin que nous puissions plus rapidement ONEWORLDPAY d'aide.",
    my_search: 'Rechercher mon problème',
    common_problem: 'problèmes courants',
    login_problem: 'Problèmes de connexion',
    unkown_charge: "L'accès non autorisé ou sinistres inconnus rapport",
    send_money: "Envoyer de l'argent",
    get_fund: "recevoir de l'argent",
    withdraw_money: "retirer de l'argent",
    pay_cancel: 'Paiement ou annuler la commande',
    pay_hold: 'Paiement en attente ou en attente',
    refund: 'Les remboursements',
    pre_pament: 'paiements pré-approuvés',
    negative_balance: 'solde négatif',
    account_qa_1:
      "ONEWORLDPAY retirer de mon compte de l'état mais il montre que « terminé » Pourquoi est-argent qui ne contient pas de compte bancaire?",
    account_qa_2:
      'Quelle est la raison de mon ONEWORLDPAY de retrait est encore un statut « en attente »?',
    account_qa_3: 'Pourquoi mon retrait en attente?',
    item_title: 'Access Password et compte',
    item_title_2: 'Profil du compte et paramètres',
  },
  business: {
    no_trade: "Il n'y a pas les marchés des changes possibles.",
    view_your_account: 'Afficher lintégralité de votre compte',
    available: 'disponible',
    calculate_late: 'Récemment montant estimé sur la base du taux de change.',
    payment_transfe: 'les transferts de paiement',
    exchange: 'Change de devises',
    currency_update: 'Ajouter un appel',
    update_btn: 'bouton plus',
    currency_cal: 'Convertisseur de devises',
    pay_default: 'Préférences de paiement',
    payment_send: 'Envoyer ou demande de paiement',
    account_list: 'Liste des comptes',
    no_alias: 'Aucun alias',
    new_bank: 'Connectez la nouvelle banque',
    card: 'carte',
    new_card: 'Connectez la nouvelle carte',
    credit: 'crédit',
    preference_payment: 'Choisissez votre mode de paiement en ligne préférés.',
    payment_tip:
      "Lors de l'achat en ligne ou l'envoi de paiement des biens et services à l'aide de ce moyen. Vous pouvez à tout moment choisir un mode de paiement lors de votre commande.",
    payment_more: 'Renseignez-vous sur vos préférences de paiement',
    paymnet_changes: 'équilibre ONEWORLDPAY',
    debit_card: 'Carte de débit',
    currency_tip:
      'Si vous ajoutez une monnaie, tous les paiements futurs reçus dans cette devise seront crédités sur les fonds appropriés. La devise de base est utilisé pour envoyer un paiement de paiement ou de la demande.',
    currency_1: 'Dollar australien',
    currency_2: 'Franc suisse',
    currency_3: 'Couronne tchèque',
    currency_4: 'Couronne danoise',
    currency_5: 'euro',
    currency_6: 'British Pound',
    currency_7: 'Dollar de Hong Kong',
    currency_8: 'forint',
    currency_9: 'Nouveau Shekel israélien',
    currency_10: 'Peso mexicain',
    currency_11: 'Norvège Krone',
    currency_12: 'Dollar néo-zélandais',
    currency_13: 'Peso philippin',
    currency_14: 'zloty polonais',
    currency_15: 'Rouble russe',
    currency_16: 'Couronne suédoise',
    currency_17: 'Dollar de Singapour',
    currency_18: 'Baht',
    currency_19: 'New Taiwan Dollar',
    withdraw_account: 'retrait compte',
    exchanged: "Après l'échange de devises",
    exchange_rate: 'Taux de change',
    exchange_tip:
      "Le taux de change est un montant estimé en fonction du taux de change actuel, les frais d'échange est inclus dans le ONEWORLDPAY.",
    currency_default: '(A) Le Yen japonais est réglé sur la devise par défaut.',
    currency_default_notice:
      'La devise de base est utilisé pour envoyer un paiement de paiement ou de la demande.',
    currency_default_notice2:
      "Fermeture de l'appel n'a pas affiché sur la balance ne reçoit aucun paiement à l'appel.",
    currency_default2: 'JPY (s), la valeur par défaut',
    currency_quit_jp_btn: 'Fermer Dollars',
    currency_quit_btn: 'Quasi',
    bank_account: 'comptes',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'balances',
    bank_account_check: 'confirmant la Banque',
    bank_account_remove: 'Supprimer Banque',
    bank_continue: 'Voulez-vous continuer?',
    bank_tip:
      'Les transactions en attente avec les banques sont traitées après la suppression.',
    bank_this_delete: 'Supprimer Banque',
    card_tip:
      "Le compte ONEWORLDPAY Vous voulez l'utiliser sans dépenser ou limites de retrait?",
    card_confirm: 'Vérifiez la carte.',
    card_type: 'type',
    expiry_date: 'expiration',
    card_adress: 'Adresse de facturation',
    card_update: 'carte de mise à jour',
    card_delete: 'Supprimer la carte',
    card_this_delete: 'Supprimer la carte',
    card_tip2:
      'Ce mode de paiement est actuellement préféré. Une fois terminé, vous pouvez définir un mode de paiement préféré différent. Affaire est en cours (a) non défini est traité après la suppression.',
    secure_code: 'code de sécurité',
  },
  shop: {
    shop_list: 'Liste magasin',
    shop_create: 'Boutique créé',
    shop_cre_date: 'ajouté',
    shop_title: 'Nom du magasin',
    shop_id: 'ID magasin',
    shop_state: 'état',
    shop_work: 'travail',
    shop_detail: 'plus',
    shop_retouch: 'cristal',
    shop_settlement: 'Liste des comptes de règlement',
    shop_history: 'transactions',
    no_shop_history: "Il n'y a pas d'historique des transactions.",
    no_shop_list: "Il n'y a pas de liste de magasins",
  },
  merchant: {
    create: 'inscription boutique',
    update: 'inscription',
    retouch: 'magasins modifiés',
  },
  pay_legal: {
    service_usage: "ONEWORLDPAY Conditions d'utilisation",
    detail_usage:
      "Les présentes conditions générales seront applicables à la région Asie-Pacifique, en Amérique latine et dans certains pays d'Europe, du Moyen-Orient et les utilisateurs africains. choisissez dans la liste ci-dessous pour afficher les termes et conditions pour les différents pays ou régions,.",
    nation: 'Sélectionnez un pays',
    every_consumer: 'tous les utilisateurs',
    service_agree: 'Votre contrat pour le service ONEWORLDPAY',
    privacy_state: 'Politique de confidentialité',
    purpose_policy: 'ONEWORLDPAY utilisation Politique',
    payment_agreement: 'accord de méthode de paiement ONEWORLDPAY',
    sell_buy: 'Marchand et affaires',
    shop_policy: 'Politiques ONEWORLDPAY Assistance Boutique',
    contract_profit: 'Contrat but lucratif',
    billing_agreement: 'Accord de facturation',
    direct_debit_agreement: 'fonds ONEWORLDPAY reçus et accords de débit',
    additional_info: 'Informations supplémentaires',
    infringement: 'Somyeongseo violations de la politique',
    policy_update: 'Mises à jour des politiques',
    warn1:
      'Informer les consommateurs: service de paiement ONEWORLDPAY est considéré comme un moyen de paiement prépayé (Facility Stored Value) conformément à la loi australienne.',
    warn2:
      "ONEWORLDPAY les propriétaires de moyens de paiement prépayés ⓒ ONEWORLDPAY All rights reserved ne nécessite pas l'approbation de l'Autorité de surveillance financière australienne. Nous encourageons également les consommateurs (utilisateurs) sont lus attentivement les présentes Conditions Générales.",
    warn3:
      "Ces conditions d'utilisation et avis fournissent les conditions associées à un service de ONEWORLDPAY particulier.",
  },
  pay_privacy: {
    effective_day: 'Entrée en vigueur le 28 Mars 2019',
    summary: 'résumé',
    personal_data: 'Les données personnelles collectées par ONEWORLDPAY',
    personal_date_cause:
      'Raisons de garder votre ONEWORLDPAY des données personnelles',
    summary_1: 'Nos membres sont',
    summary_2: 'Sites',
    summary_3: 'ou visite',
    summary_4: 'service',
    summary_5: 'Lorsque vous utilisez les utilisateurs de',
    summary_6: 'données personnelles',
    summary_7:
      "Comment collecter et stocker, gérer et partager, en expliquant que le transfert a préparé cette Politique de confidentialité. Cette politique de confidentialité s'applique à vos données personnelles lorsque vous visitez notre site ou utiliser le service, les autres ONEWORLDPAY",
    summary_8: 'utilisateur',
    summary_9:
      'Il ne concerne pas les sites ou ONEWORLDPAY web en ligne ou non la propriété des ajustements, y compris le site ou le service service.',
    summary2_1:
      'ONEWORLDPAY peut vous visitez nos sites ou collecter des informations personnelles lorsque vous utilisez les types de services suivants.',
    summary2_2: 'Utilisation et information Up',
    summary2_3:
      "Lorsque vous vous inscrivez un compte pour utiliser les services de ONEWORLDPAY, pour répondre aux informations nécessaires pour recueillir des données personnelles afin de fournir le service demandé par l'utilisateur.",
    summary2_4:
      "En fonction des services sélectionnés, vous pouvez demander de fournir les informations d'identification requises pour créer un nom d'utilisateur, adresse postale, numéro de téléphone, adresse e-mail, compte.",
    summary2_5:
      'Conditions vous pouvez demander de fournir des données personnelles supplémentaires, en fonction du service.',
    summary3_1: "expérience du trading et de l'information",
    summary3_2:
      "En utilisant les services de ONEWORLDPAY ou si l'accès au site, par exemple, acheter du vendeur, ou la réception de l'argent ou si le traitement d'un paiement ou envoyer de l'argent à des amis et la famille, recueillir d'autres informations relatives à la négociation, ainsi que des informations sur les transactions de ONEWORLDPAY la. Autres informations liées au commerce comprend l'envoi ou demander de l'argent, des biens ou services de paiement de l'argent, le vendeur, y compris des informations sur tous les modes de paiement utilisés pour compléter les informations de l'information sur les transactions et le dispositif, les données de la technologie, des informations de localisation, etc..",
    summary4_1: 'Renseignements sur les participants',
    summary4_2:
      "Lorsque vous utilisez ou l'accès au service site ONEWORLDPAY collecte des données personnelles que les utilisateurs fournissent d'autres participants impliqués dans l'affaire.",
    summary4_3: "Pour envoyer ou de l'argent à la demande",
    summary4_4:
      "Si vous envoyez ou demande d'argent par le service ONEWORLDPAY recueillir votre nom, votre adresse postale, numéro de téléphone, données personnelles telles que reçoivent de l'argent de vos informations de compte financier du participant d'envoyer de l'argent pour vous.",
    summary4_5:
      "La portée des données personnelles demandées par rapport aux participants peut varier en fonction du service utilisé pour envoyer ou de l'argent à la demande.",
    summary5_1:
      'Le paiement des autres personnes au lieu des factures ou facture demandant le paiement à une autre personne',
    summary5_2:
      "Si vous utilisez un service de ONEWORLDPAY pour leur demander de payer la facture au nom d'une autre personne, ou de payer vos factures en leur nom à un autre utilisateur, le nom d'utilisateur, adresse postale, numéro de téléphone, adresse e-mail, la facturation de l'utilisateur au lieu de factures ou d'autres le propriétaire du compte doit recueillir des données personnelles pertinentes, y compris le numéro de compte que vous voulez payer à la place.",
    summary6_1: "Ajouter de l'argent à votre compte",
    summary6_1_1: 'votre compte',
    summary6_2:
      "Pour ajouter de l'argent à d'autres comptes dans le compte de l'utilisateur ou l'utilisateur peut posséder, ou si vous utilisez un service de ONEWORLDPAY pour demander à ajouter au montant de ce compte aux autres utilisateurs de l'autre côté de l'utilisateur pour traiter efficacement votre demande recueillir de l'information ou peut recueillir des informations sur vous de l'autre côté.",
    summary6_3:
      "Par exemple, charger ou d'utiliser la demande des services de ONEWORLDPAY à ajouter au montant dans le compte à un téléphone mobile, vous pouvez recueillir d'autres renseignements, y compris les données personnelles, et le numéro de compte mobile des autres participants.",
    summary7_1:
      'Les informations relatives à la personne de vos amis et contacts',
    summary7_2:
      "Lorsque l'utilisateur se connecte la liste de contacts dans votre compte, il est plus facile de donner aux gens d'aider à traiter quand ONEWORLDPAY avec vos amis et contacts. Pour que l'utilisateur peut utiliser l'appareil, ou mettre en place une connexion entre les plates-formes de médias sociaux ou des dispositifs aux comptes ONEWORLDPAY ou les médias sociaux lorsqu'ils sont connectés à la plate-forme de meilleurs services de ONEWORLDPAY recueillir et utiliser vos informations de contacts de la liste (nom, adresse, adresse e-mail, etc.) ONEWORLDPAY améliorer l'environnement.",
    summary8_1:
      "Les informations que vous choisissez de fournir ONEWORLDPAY afin d'utiliser certains services en ligne ou des services supplémentaires",
    summary8_2:
      "Si la demande ou de participer à la sélection du site à des fonctions de demande ou des services améliorés, ou d'autres fonctions optionnelles, vous pouvez recueillir des informations supplémentaires sur les utilisateurs ONEWORLDPAY.",
    summary8_3:
      "Si les méthodes utilisées pour recueillir des informations de ces services diffèrent de ceux énoncés dans la présente Politique de confidentialité, les informations recueillies au cours d'un avis distinct.",
    summary9_1:
      "Informations pour l'utilisateur lors de l'utilisation du service « non-paiement ONEWORLDPAY »",
    summary9_2:
      "Pour certains services limités peuvent avoir besoin de vous connecter ou utiliser vos paramètres de compte non-paiement. ONEWORLDPAY recueillera vos données personnelles, toutes les méthodes de paiement d'information de l'appareil concerné, les données technologiques, les informations de localisation nécessaires à l'utilisateur de compléter la transaction. Lorsque vous sélectionnez le propriétaire du compte et le paiement de la non-négociation, vous pouvez construire et de recueillir des informations sur les transactions associées à votre compte.",
    summary9_3:
      "Si l'utilisateur sans le propriétaire du compte et sélectionnez le paiement pour la transaction non ONEWORLDPAY, rassemblons et stockons toutes les informations que vous fournissez sont utilisées et partagées conformément aux informations contenues dans la présente Politique de confidentialité.",
    summary10_1: "informations spécifiques à l'utilisateur auprès de tiers",
    summary10_2:
      "D'un tiers, comme marchand, les fournisseurs de données, les bureaux de crédit dans la mesure permise par la loi, vous pouvez obtenir les informations.",
  },
  partner: {
    be_partner: 'Devenez partenaire de ONEWORLDPAY.',
    banner_text:
      'Achats fournisseur de plate-forme, le marché, il est un des opérateurs de support de facturation qui nécessitent un fournisseur de services de paiement peut être un partenaire de ONEWORLDPAY.',
    banner_btn: 'Pour contacter votre gestionnaire de compte',
    benefit: 'avantages ONEWORLDPAY que les partenaires ont droit',
    benefit_1:
      "L'intégration et le support technique des solutions de construction",
    benefit_2:
      "S'il vous plaît ne hésitez pas à contacter notre équipe d'assistance pour vous d'obtenir de l'aide en matière d'intégration de ONEWORLDPAY. portail développeur ONEWORLDPAY peut également être utilisé comme ressource.",
    benefit_3:
      'La croissance des entreprises grâce à des possibilités de marketing',
    benefit_4:
      'Profitez des nombreuses possibilités de commercialisation prévues ONEWORLDPAY peut attirer des clients potentiels.',
    traction: 'Et le remorquage des paiements dans le monde entier.',
    traction1:
      'partenaires ONEWORLDPAY soutiennent une plate-forme innovante pour un bon règlement des vendeurs à ONEWORLDPAY de confiance.',
    traction_btn: 'plus de partenaires',
    program: "ONEWORLDPAY Partner Program est libre d'adhérer.",
    program_1:
      "S'il vous plaît remplir le formulaire en ligne, nous vous contacterons ONEWORLDPAY.",
    program_2:
      "S'il vous plaît décrire les solutions d'affaires opérationnelles et en cours d'exécution.",
    program_3:
      "S'il vous plaît ONEWORLDPAY de contact pour discuter des changements nécessaires.",
    program_4:
      "ONEWORLDPAY intégrer et veillons à ce qu'ils reçoivent le paiement ONEWORLDPAY.",
    program_btn: 'Pour contacter votre gestionnaire de compte',
    common_qa: 'Foire aux questions',
    common_qa1: 'Y at-il des fournisseurs partenaire ONEWORLDPAY?',
    common_qa1_text:
      "partenaire ONEWORLDPAY est la société B2B (business-to-business) qui offre à ses clients des solutions ONEWORLDPAY. ONEWORLDPAY travaille avec des organisations telles que le panier d'achat, les entreprises d'hébergement Web, les développeurs web, fournisseurs de services logistiques et agence de marketing numérique, passerelle de paiement.",
    common_qa2: 'Quels sont les partenaires de ONEWORLDPAY admissibles?',
    common_qa2_text: 'Contactez votre gestionnaire de compte',
    common_qa2_text_2:
      'Vous pouvez obtenir des conseils sur les qualifications des partenaires.',
    common_qa3:
      'Nous fournissons des services de soutien intégrés dans le ONEWORLDPAY?',
    common_qa3_text:
      "Une fois inscrit au programme de partenariat et d'approbation ONEWORLDPAY à se joindre, vous pouvez accéder aux précieux documents intégrés et des forums développeurs. Il peut également obtenir un support intégré pour les consultants du certificat.",
    common_qa4:
      'Il y a aussi un en dehors des affaires de Corée, puis-je inscrire séparément pour chaque pays dans le programme de partenariat?',
    common_qa4_text:
      'Cela dépend du pays dans lequel vous exploitez une entreprise. Dans ONEWORLDPAY déploient représentant des partenaires spécialisés aux besoins régionaux dans divers pays.',
    common_qa4_more: 'Voir le programme de partenariat national offre',
  },
  pay_main: {
    total_product: 'total des produits',
    total_sum: 'agrégat',
    pay_this_account: 'Définissez ce compte comme mode de paiement.',
    bill_show:
      'Les informations de la transaction est affichée comme suit dans le cahier des charges.',
    banner_text: 'ONEWORLDPAY est plus sûr',
    banner_text2: 'Un paiement rapide.',
    banner_text3:
      'Peu importe où le shopping gardera vos informations financières sécurisées.',
    footer_1: 'Termes et conditions',
    footer_2: "Conditions générales d'utilisation",
    footer_3: 'Politique de confidentialité',
    footer_4: "retour d'information",
    footer_5:
      "Notification aux consommateurs: Profil de la Banque Coco Le propriétaire du paiement prépayé signifie ⓒ Cocobank Tous les droits réservés ne nécessitent pas l'approbation de l'autorité de surveillance financière suédoise.",
    footer_6: "Conditions d'utilisation",
    footer_7: 'Nous vous encourageons également à lire attentivement.',
    footer_8: 'facturation',
    wallet: 'gestion porte-monnaie',
    last_name: 'sexe',
    card_number: 'Numéro de la carte',
    three_number: 'trois chiffres',
    name: 'nom',
    pay_cocopay: 'Pour payer par ONEWORLDPAY',
    free_shipping:
      "Si le compte ONEWORLDPAY, vous pouvez obtenir expédition de retour gratuit, l'achat de protection.",
    email_phone: 'Numéro de courriel ou par téléphone',
    login_error: 'Avez-vous du mal à la signature?',
    pay_card: 'Paiement par carte',
    cancel_back: 'Annuler et revenir à la page précédente',
  },
  site_map: {
    site_map_tip: 'Un lien qui vous aidera à explorer le compte ONEWORLDPAY.',
    map_fund: 'fonds',
    map_fund_1: 'DÉBITÉES',
    map_fund_2: 'Ma capacité à utiliser le solde est?',
    map_fund_3: "Envoyer ou demande d'argent",
    map_fund_4: 'gestion des appels',
    map_fund_5: 'ONEWORLDPAY mes remises de cartes de débit',
    map_fund_6: 'Obtenez ONEWORLDPAY carte de débit',
    map_fund_7: 'ONEWORLDPAY crédit Calendrier de facturation',
    map_deal: 'affaire',
    map_deal_1: 'Voir toutes les activités de traite',
    map_deal_2: 'Activités vues (y compris le solde et les frais)',
    map_deal_3: 'Voir les graphiques et les tableaux offre',
    map_deal_4: 'Télécharger affaire',
    map_deal_5: 'En réponse à une demande ou rétrofacturation',
    map_deal_6: 'IPN (notification de paiement instantanée) Histoire',
    map_profile: 'Mon profil et vos paramètres',
    map_profile_1: "Miroir d'affaires",
    map_profile_2: 'E-mail, adresse, téléphone ou mise à jour du mot de passe',
    map_profile_3: 'compte bancaire ou mise à jour de la carte',
    map_profile_4: 'Mise à jour Notifications',
    map_profile_5: 'Limites Voir le compte',
    map_profile_6: 'Gestion des utilisateurs',
    map_profile_7: 'Préférences de mise à jour de livraison',
    map_support: 'soutien',
    map_support_1: 'Accédez au Centre for Conflict Resolution',
    map_support_2: 'Accédez au Centre de support',
    map_support_3: 'Contactez-nous',
    map_support_4: 'ONEWORLDPAY information sur les frais de marchand',
    map_report: 'rapport',
    map_report_1: 'Rapport de mettre en place, gérer ou télécharger',
    map_manage: 'outils',
    map_manage_1: 'Voir outil',
    map_manage_2: 'Gestion bouton ONEWORLDPAY',
    map_manage_3: 'Gestion des paiements réguliers',
    map_consum: 'client',
    map_consum_1: 'Voir la liste des clients',
  },
  fee: {
    fee_tip: 'Structure Fief simple',
    fee_banner_1:
      "En règle générale, l'achat est gratuit et peut être soumise à des frais de change.",
    fee_banner_2:
      "Si les ventes ne collent pas avec les frais mensuels de ONEWORLDPAY, ou les frais d'annulation. Après chaque commission ne sera versée que.",
    fee_h2: "En général l'achat est gratuite.",
    fee_text1:
      'Les frais de traitement des paiements sont payés par le vendeur.',
    fee_text2: 'Cependant, vous pouvez échanger des frais est appliqué.',
    fee_more: 'frais de vente en savoir plus',
    fee_text3:
      "Vente par la facture ou le paiement Email site Web (paiement tarifs internationaux standard s'appliquent)",
    fee_text4: 'Des frais fixes en fonction de la réception des appels',
    fee_text5: "frais d'échanges peuvent demander plus.",
    fee_text6:
      'Par exemple, pour un reçu de paiement des frais fixes en USD est de 0,30 $ USD.',
  },
  dash: {
    more: 'plus',
    withdraw_asset: 'retrait des fonds',
    currency: 'monnaie',
    quotes: 'Les factures et des prévisions budgétaires',
    last_6_months: '6 derniers mois',
    make_invoice: 'génération de facture',
    manage_invoice: 'gestion des factures',
    grown_up:
      "S'il vous plaît envoyer à faire croître l'entreprise pour obtenir un devis.",
    un_paid_invocie: 'factures impayées',
    make_quotes: 'génération de devis',
    quotes_1: 'On a proposé des factures impayées.',
    quotes_2: 'facture ONEWORLDPAY',
    quotes_alarm: 'Envoyer des rappels',
    quotes_detail: 'Afficher plus',
    quotes_who: 'Bill à: Choi, So - Jeune',
    latest_act: 'Activité récente',
    act: 'activité',
    received: 'Paiement reçu',
    send: 'de paiement',
    act_record: 'Activité (y compris le solde et les frais)',
    pay_person: 'personnes Biller',
    show_all: 'voir tous les',
    tell_us: "S'il vous plaît dites-nous votre opinion.",
    feed_text:
      "S'il vous plaît prendre un moment pour nous dire votre avis sur les informations d'affichage nouvellement conçu sur cette page. Merci!",
    service: 'formuler des commentaires',
    feed_text_back:
      'Merci pour vos commentaires! Est-ce que notre site est utile?',
    feed_placeholder:
      "S'il vous plaît laissez-moi savoir la raison pour laquelle il y a une meilleure façon que je suis venu aujourd'hui ONEWORLDPAY. Ne pas inclure des informations personnelles, telles que le numéro de compte e-mail ou.",
    feed_p:
      "le personnel du bureau de ONEWORLDPAY et les invités à vos commentaires peuvent être affichés à l'interne, de sorte que vous pouvez le voir, ne laissez aucune information personnelle. problèmes de service à la clientèle, s'il vous plaît cliquer ici. de ONEWORLDPAY",
    feed_protect: 'Politique de confidentialité',
    feed_law: 'Conditions juridiques',
    feed_or: 'et',
    feed_need: 'voir',
    trade_name: 'Nom Deal',
    trade_id: 'ID Deal',
    transaction_type: 'le type de contrat',
    trade_amount: 'paiement',
    detail_show: 'Rechercher',
  },
  shop_detail: {
    detail_info: 'Détails boutique',
    api_signature: 'clé de signature de magasin',
    msg_shop_create: 'Cette boutique a été enregistré.',
    msg_shop_modify: 'Cette boutique a été corrigé.',
  },
  merchant_account: {
    create_account: 'Générer compte de règlement',
    enroll_account: "Compte de règlement d'enregistrement",
    pls_select_account: 'Choisissez établissement compte',
  },
  transaction_detail: {
    select_pay_account: 'Sélectionnez un compte de paiement',
    transaction_title: 'détails Deal',
    order_id: 'Magasin Numéro de commande',
    pay_account_title: 'Nom du compte de paiement',
    pay_account_number: 'Compte Paiement Nombre',
    pay_account_balance: 'Compte paiement du solde',
  },
  guide: {
    title: 'guide de commerce C2C',
    watch_video: 'Voir les images',
  },
  account_transfer: {
    transfer: 'Transfert de compte',
    transfer_list: 'Historique du transfert',
    msg_required_data: "S'il vous plaît entrer toutes les valeurs",
    msg_not_select_withdraw_account:
      "S'il vous plaît sélectionnez le compte de paiement",
    create_transfer_title: 'Transfert de compte',
    from_account_select: 'Sélectionnez le compte de paiement',
    available_transfer: 'les montants de transfert',
    to_account_input: 'Transfert entrée du numéro de compte',
    to_account_confirm: 'Transfert de vérification des comptes',
    to_account_user_name: 'Transfert compte Nom du membre',
    transfer_amount: 'Montant du transfert',
    delete_amount: 'correction',
    all_amount: 'COMPLET',
    description: 'explication',
    transfer_btn: 'transferts',
    transfer_btn_2: 'transferts',
    transfer_info_check: 'Consultez les informations de demande de transfert',
    transfer_info_check_2: 'Consultez les informations de demande de transfert',
    from_account_number: 'Retrait Numéro de compte',
    from_asset_title: 'Retrait des actifs compte',
    to_account_number: 'Transfert Numéro de compte',
    success_transfer: 'Transfert a été traitée avec succès.',
    success_withdraw: 'Le retrait a été traité avec succès.',
    transfer_list_detail: 'Transfert Histoire &',
    search_transfer_asset: 'Recherche par la propriété',
    search_transfer_account: 'Recherche par compte',
    reset: 'initialisation',
    search: 'récupération',
    transfer_list_detail_tit: 'Transfert Détails Détails',
    no_transfer: 'Aucun détail de transfert',
    msg_not_search_account:
      "Le numéro de compte n'existe pas ou est entrée valide.",
    my_account_transfer: 'Mes transferts de compte',
    msg_pls_select_account:
      'Après avoir sélectionné un actif, recherchez le compte.',
    placeholder_amount: "S'il vous plaît entrer le montant de transfert",
    not_search_user_name: 'Identifiants sûr',
    msg_select_asset_search: 'Veuillez sélectionner un compte',
    success_fail: 'Le transfert a échoué.',
    pls_search_asset: 'Recherchez des actifs.',
    pls_search_account: 'Recherchez votre compte.',
    pls_select_asset: 'Veuillez sélectionner un élément.',
    select_account_first: "Veuillez d'abord sélectionner un compte.",
    select_market_first: "Veuillez d'abord sélectionner le marché",
    not_exist_account: "Le compte de l'actif n'existe pas.",
    favorites: 'Favoris',
    no_inquiry_history: "Il n'y a pas d'historique d'enquête.",
    from_user_name: 'Membres du compte en retard',
  },
  bank_service_center: {
    title: 'sujet',
    date: 'date',
    state: 'état',
    enter_search_word: 'Entrez vos termes de recherche',
    list: 'liste',
  },
  service_center: {
    view_all: 'Voir tous les',
    contact_history: "Historique de l'enquête",
    privacy_Statement: 'Politique de traitement des informations personnelles',
    would_you_agree: 'Souhaitez-vous accepter ce qui précède?',
    mobile_number: 'Numéro de téléphone portable',
    target_of_inquiry: "Objet de l'enquête",
    inquiry_contents: "Contenu de l'enquête",
    please_enter_your_inquiry: 'Veuillez saisir votre demande.',
    send: 'Envoyer',
    normal_inquiries_received: 'Votre demande a bien été reçue.',
    inquiry_history: "Historique de l'enquête",
    pls_select_inquiry_type: "S'il vous plaît sélectionner le type de contact",
    pls_login_to_use_inquiry: '1, Connectez-vous à premières enquêtes.',
    non_member_login: 'Connexion non-membre',
    contact_id: 'Contact ID',
    view_inquiry: 'Afficher le contact',
    service_center: 'centre client',
    inquiry_details: 'Détails de contact',
    msg_enter_title: "S'il vous plaît donner un titre.",
    msg_enter_your_content: "S'il vous plaît entrer vos informations.",
    msg_pls_login: "S'il vous plaît Connectez-vous.",
    go_back: 'Retour',
    re_contact: 'Matériau du contact',
    contents: 'contenu',
    msg_no_inquiry_history: 'Aucun détail de contact.',
    msg_require_login_additional_authentication:
      'Vous devez être connecté ou une authentification supplémentaire.',
    when_you_member: "Lorsqu'un membre",
    msg_inquiry_history_can_view_after_login:
      'Les membres des coordonnées peuvent être consultés après la connexion.',
    non_member: 'Lorsque les non-membres',
    lookup_inquiry: 'Recherche de contacts',
    msg_enter_inquiry_id: "S'il vous plaît entrer le numéro de contact.",
    msg_enter_password_when_registering_your_inquiry:
      "S'il vous plaît entrer le mot de passe que vous définissez lorsque vous appelez registre.",
    frequently_asked_questions: 'Foire aux questions',
    msg_enter_your_password: "S'il vous plaît entrer votre mot de passe.",
  },
  modal: {
    not_seeing_day: 'Pas vu pendant la journée',
  },
  login_guide_modal: {
    title: "L'information",
    sub_title:
      "Le système de connexion sera remanié pour que les membres puissent utiliser l'échange en douceur.",
    content:
      "[Avant le changement] <br/> Identifiant créé lors de votre première inscription <br/><br/> [Après le changement] <br/> Modifiez votre numéro de téléphone ou votre adresse e-mail <br/><br/> Pour vous connecter jusqu'à ce que le système de connexion soit réorganisé, connectez-vous simplement avec l'ID que vous avez créé lors de votre première inscription.",
  },
  affiliate: {
    affiliate_occur_list: 'Historique des allocations',
    affiliate_adjust_list: "Détails du règlement de l'allocation",
    allowance_balance_asset: 'Solde des allocations par actif',
    list_allowance_balance_asset: 'Liste du solde des allocations par actif',
    search_by_asset: 'Recherche par actif',
    allowance_search: "Recherche d'allocation",
    generator: 'Générateur',
    beneficiary: 'Bénéficiaire',
    benefactor: 'Bienfaiteur',
    behavior_type: 'Type de comportement',
    target_unique_number: 'Numéro unique cible',
    date_of_occurrence: "Date de l'événement",
    application_policy_name: "Nom de la stratégie d'application",
    beneficiary_type: 'type de bénéficiaire',
    benefactor_type: 'type de bienfaiteur',
    target_amount: 'Montant cible',
    principal_amount: 'Le montant principal',
    allowance: 'rémunération supplémentaire',
    allowance_assets: 'Actifs d’allocation',
    allowance_amount: "Montant de l'allocation",
    affiliate_log: 'Répartition des allocations',
    allowance_settlement: 'Règlement des indemnités',
    allowance_settlement_info: 'Informations sur le règlement des allocations',
    name_asset_settled: 'Nom des actifs à régler',
    balance_receive_payment: 'Solde à payer',
    select_account_settled: 'Sélectionnez le compte à régler',
    no_affiliate_log: "Il n'y a aucune allocation encourue.",
    no_affiliate_balance:
      "Il n'y a pas de liste des soldes de provisions par actif.",
    no_affiliate_adjust: "Il n'y a aucun historique de paiement d'allocation.",
    asset_name: "Nom de l'actif",
    asset_code: "Code d'actif",
    balance: 'équilibre',
    cumulative_amount: 'Montant cumulé',
    please_select_account: 'Veuillez sélectionner un compte',
    calculate: 'Calculer',
    settle: 'Régler',
    calculate_amount: 'Montant du règlement',
    account_number: 'Numéro de compte',
    registration_date: "Date d'inscription",
    number: 'nombre',
  },
  Coin_name: 'Nom de la pièce',
  main_function: 'Fonction rincipale',
  disclosure_ing: 'En cours de',
  market_balance_transfer: 'Transfert de solde de marché',
  available_after_login: 'Disponible après connexion.',
  fast_stable_deal: 'avec des transactions rapides et stables',
  cryptocurrency_exchange: 'Les échanges de Cryptocurrency',
  go_transaction: 'Aller Transaction',
  create_an_account: 'Créer un compte',
  more_than_that: ' valent plus que cela.',
  vision_title: 'Vision basée sur la confiance',
  vision_text1:
    " ONEWORLDPAY utilise la technologie blockchain dans un nouvel écosystème d'actifs numériques.",
  vision_text2: 'Vision basée sur la confiance',
  fee_title: 'Avantages tarifaires',
  fee_text1:
    'Exonération des frais de création de compte, exonération des frais de tenue de compte,',
  fee_text2: "Exonération des frais d'achat / vente",
  row_title: "Faible barrière à l'entrée",
  row_text1: 'Bitcoin, Ethereum, etc',
  row_text2: 'Vous pouvez échanger.',
  easy_title: 'Interface confortable',
  easy_text1:
    'Une transaction simple que même les débutants peuvent facilement échanger',
  easy_text2: 'Transaction à temps plein',
  full_time: 'transaction à temps plein',
  full_time_text1:
    "N'importe quand, n'importe où, 24 heures sur 24, 365 jours par an si vous avez un téléphone portable et un ordinateur",
  full_time_text2: 'La transaction est possible.',
  easy_sellbuy: "Transaction pratique à tout moment, n'importe où",
  so_easy: 'Facile et confortable',
  b2c_mobile: 'Application mobile B2C',
  app_sellbuy:
    "orsque vous effectuez des transactions avec un appareil mobile via l'application",
  anywhere_use: "Vous pouvez le faire avec B2C à tout moment, n'importe où.",
  now_start_buy: 'Commencez à négocier dès maintenant.',

  procedure:
    "Lors de la connexion après avoir accédé à ONEWORLDPAY.COM/COCOBNK.COM, le processus d'approbation pour le partage d'informations est en cours, et ce processus est une procédure obligatoire pour la connexion SNS (connexion sociale). Si la procédure de connexion via SNS n'est pas effectuée, vous ne pouvez pas vous connecter à ONEWORLDPAY / COCOBNK, et cette procédure est effectuée conformément à la loi sur les réseaux d'information et de communication et à la loi sur la protection des informations personnelles.",
  snslink: "La connexion demandée dans l'état de la liaison de compte SNS est",
  four_one:
    "Article 4 ① Le Ministre de la science, de la technologie et de la communication ou la Commission coréenne de la communication jette les bases de la société de l'information par la promotion de l'utilisation des réseaux d'information et de communication, une gestion stable et la protection des utilisateurs (ci-après dénommée «promotion des réseaux d'information et de communication et protection de l'information»). Des mesures doivent être préparées pour ce faire.",
  four_two:
    '② La politique conformément au paragraphe 1 comprend les éléments suivants.  ',
  eight:
    "8. Amélioration de la sécurité et de la fiabilité des réseaux d'information et de communication",
  nine:
    "9. Autres questions nécessaires à la promotion de l'utilisation des réseaux d'information et de communication et de la protection de l'information, etc.",
  execution: 'Il est mis en œuvre conformément à ses dispositions.',
  privacy: 'De plus, la loi sur la protection des renseignements personnels',
  twentyfour_three:
    "Article 24 (Restriction du traitement des informations d'identification unique) ③ Lorsqu'un responsable du traitement des informations personnelles traite des informations d'identification unique conformément à chacun des alinéas du paragraphe 1, les informations d'identification unique ne sont pas perdues, volées, divulguées, falsifiées, modifiées ou endommagées. Les mesures nécessaires pour garantir la sécurité, telles que le cryptage, doivent être prises conformément au décret présidentiel.",
  twentyfour_two:
    "Article 24-2 (Restrictions sur le traitement des numéros d'enregistrement des résidents) ② Les responsables du traitement des informations personnelles doivent protéger leurs numéros d'enregistrement de résidents grâce à des mesures de cryptage afin qu'ils ne soient pas perdus, volés, divulgués, falsifiés, modifiés ou endommagés malgré l'article 24, paragraphe 3. Dans ce cas, les questions nécessaires concernant le sujet auquel le cryptage est appliqué et le moment de l'application pour chaque sujet seront déterminés par décret présidentiel, en tenant compte de l'ampleur du traitement des informations personnelles et de l'impact des fuites.",
  implemented: 'Il est mis en œuvre conformément à ses dispositions.',
  we_future: 'notre futur',
  pop_cocobank: 'COCO BANK',
  fourth_industry: 'Leader dans la quatrième industrie',
  oc_15: '15 octobre',
  officially_open: 'Officiellement ouvert!',
  head_branch_office:
    'Siège social en Corée (succursale de Jamsil) / 1re succursale (succursale de Sinsa)',
  sep_15: '15 septembre à 17h',
  open_popup: 'Ouvert',
  thanks_for: 'Merci pour vos encouragements.',

  kiosk: {
    make_pay: 'Effectuer un paiement',
    product_name: 'nom du produit',
    amount_payment: 'Montant du paiement',
    may_pay_guide_txt:
      'Le paiement est effectué en scannant le <br /><span style="font-weight:900; color:#2369b0;">code QR de paiement ONEWORLDPAY {os}</span> <br />sur le terminal.',
    app_download_btn: 'Installez ONEWORLDPAY {os}',
    app_download_qr_scan: "Scannez le code QR pour télécharger l'application.",
    app_install_txt:
      'Veuillez scanner le code QR ci-dessous et installer <br /><span style="font-weight: 900; color: #1f67af">ONEWORLDPAY {os}</span>',
    app_install_sub_txt:
      'Page de paiement ONEWORLDPAY Scannez le code QR sur le terminal pour procéder au paiement.',
    app_install_sub_txt2:
      'Le service ONEWORLDPAY ios sera fourni ultérieurement.',
    direct_exchange_txt:
      '<strong>Échangez </strong><span>des </span><strong>{asset1}</strong><span>contre des </span><strong>{asset2}</strong>',
    bank_use: 'utiliser la banque',
    cocobank: 'ONEWORLDPAY',
    cocobank_account_transfer: 'Transfert de compte ONEWORLDPAY',
    store_use: 'ordre',
    location_store: 'co.u co.u',
    home_ad_1: 'Premier marché libre de pièces de monnaie au monde',
    home_ad_2: 'COCO MARKET',
    use: 'Comment utiliser',
    bank_direct_ex: "J'échangerai de l'argent tout de suite",
    deposit_inquiry: 'Enquête',
    deposit_inquiry_txt: 'Vérifier le compte ONEWORLDPAY',
    deposit_withdrawal: 'Retrait',
    deposit_withdrawal_txt: "Cela prendra 10 à 10 minutes après l'application.",
    deposit_transfer: 'Transfert',
    deposit_transfer_txt: 'Remise sur le compte ONEWORLDPAY',
    wallet_transfer: 'Transfert de portefeuille',
    wallet_transfer_txt: "Transfert vers le portefeuille d'un autre échange",
    exchange_list: 'Historique du change de devises',
    certified: 'Gestion de la certification',
    certified_drawer_title: 'Gestion de la certification',
    direct_transaction: 'Transaction directe',
    direct_transaction_txt: 'Échangez immédiatement',
    c2c_transaction: 'Transaction C2C',
    c2c_transaction_txt: 'Trading cryptographique client',
    account_application: 'Demande de compte',
    account_application_txt: 'Demander un compte',
    terms_title1:
      'Guide pour limiter les limites pour prévenir le renforcement de la fraude financière dans les télécommunications',
    terms_text1:
      "Comme le compte demandé est ouvert sans face à face, la limite de retrait (transfert) via des appareils automatisés et Internet est limitée à 0 CCF par jour. <br /> Des données d'authentification objectives pour confirmer le but de la transaction sont présentées au succursale et 'gestion> Vous pouvez annuler la limite dans' Authentification / Gestion de la sécurité '. <br /> Lorsque vous utilisez les services bancaires par Internet, vous devez vous inscrire en tant que compte de retrait pour effectuer des transactions de transfert. ouvert seulement 5 par personne Vous pouvez.",
    terms_notice1: 'Remarquer',
    terms_notice1_txt:
      "L'abonnement Internet Banking peut être appliqué en se connectant à partir de l'écran de finalisation après l'ouverture d'un compte de dépôt et de retrait. <br /> Les clients Internet Banking existants peuvent s'inscrire pour des comptes de retrait via Internet Banking uniquement lorsque la catégorie d'enregistrement du compte de retrait est Internet + agence. Veuillez noter qu'il y en a.",
    terms_notice2:
      "&#8251; Si vous procédez d'abord à l'authentification de sécurité, vous devez créer un compte et vous inscrire en tant que compte de retrait lorsque vous utilisez Internet Banking avant de pouvoir transférer des transactions.",
    cancel: 'Annuler',
    security_authentication: 'Authentification de sécurité',
    new_registration: 'Nouvelle inscription',
    terms_title2:
      "Lorsque vous cliquez sur le nouveau bouton d'inscription, vous recevrez votre propre compte {0} Cocobank et une adresse de dépôt liée à un portefeuille externe.",
    terms_notice3: 'Assurez-vous de le savoir avant de déposer!',
    terms_notice3_text1:
      "Seul le {0} peut être déposé sur le compte / l'adresse émise lors de la nouvelle inscription. Les erreurs / pertes qui peuvent survenir si vous essayez de déposer d'autres actifs numériques à l'adresse sont irrécupérables.",
    terms_notice3_text2:
      'Après une confirmation, elle est reflétée dans le solde par le processus de dépôt. Le processus de dépôt est automatique et le temps requis peut varier en fonction des conditions du réseau.',
    terms_notice3_text3:
      "L'adresse ci-dessus est <strong> Dépôt uniquement </strong>.",
    terms_checkbox_text: 'Avez-vous accepté et compris ce qui précède?',
    assets: 'Les atouts',
    favorite: 'Favoris',
    select_assets_txt: 'euillez sélectionner un élément.',
    search_assets: "Recherche d'actifs",
    search_assets_txt: 'Veuillez rechercher un élément.',
    account_name: 'Nom du compte',
    account_name_txt: 'Veuillez saisir le nom de votre compte',
    selected_assets: 'Élément facultatif',
    account_unique_number: 'Numéro unique du compte',
    account_number: 'Numéro de compte',
    stop_amount: "Montant d'arrêt",
    state: 'Etat',
    auto_input: 'Entrée automatique',
    opening: 'Ouverture',
    application_success_txt: 'La demande de compte est terminée.',
    application_fail_text: 'La demande de compte a échoué.',
    confirm: 'confirmer',
    previous: 'précédent',
    enter_account_number: 'Veuillez saisir votre numéro de compte.',
    service_preparation: 'Préparer le service',
    service_preparation_txt1:
      'Nous préparons la page pour offrir un meilleur service.',
    service_preparation_txt2: 'Nous serons prêts et à bientôt.',
    search_account: 'Recherche de compte',
    search_account_txt: 'Veuillez rechercher votre compte.',
    select_account_txt: 'Veuillez sélectionner un compte.',
    withdrawable_amount: 'Montant retirable',
    inquiry_period: 'Période de demande',
    variable_amount: 'Montant variable',
    no_deposit_history: "Il n'y a pas d'historique des demandes de dépôt.",
    select_date: 'sélectionner une date',
    type_of_change: 'Type de changement',
    sort_order: 'Ordre de tri',
    inquiry_option: 'Option de requête',
    select_market: 'Sélection de marché',
    reduction_rate: 'Taux de commission',
    sales_quantity: 'Quantité de vente',
    minimum_purchase_quantity: "Quantité minimum d'achat",
    selling_price_per_piece: 'Prix ​​de vente par pièce',
    account_for_registration_of_sales: "Compte d'enregistrement des ventes",
    purchase_assets: 'Acheter des actifs',
    available_quantity: 'Quantité disponible',
    purchase_quantity: "Quantité d'achat",
    price_per_piece: 'Prix ​​par pièce',
    quantity_to_be_paid: 'Quantité à payer',
    select_account_to_receive: 'Sélectionnez le compte pour recevoir',
    registration_was_successful: "L'enregistrement fut un succès",
    registration_failed: "Échec de l'enregistrement.",
    go_to_first: 'Pour la première fois',
    purchase_history: "Historique d'achat",
    purchase_price: "Prix ​​d'achat",
    no_description: "Il n'y a pas de description.",
    sales_history: 'Historique des ventes',
    price_per_quantity: 'Prix ​​par quantité',
    total_fee: 'Montant total',
    no_disclosure_details: "Il n'y a pas de détails de divulgation.",
    advanced_search: 'Recherche Avancée',
    sales_registration: 'Enregistrement des ventes',
    purchase_registration: "Inscription à l'achat",
    verification_completed: 'Vérification terminée',
    email_authentication: 'Authentification par courriel',
    authenticate: 'Authentifier',
    identity_verification: "Vérification d'identité",
    otp_authentication: 'Authentification OTP',
    withdrawal_address_verification: "Vérification de l'adresse de retrait",
    withdrawal_address_application_details:
      "Détails de la demande d'adresse de retrait",
    no_withdrawal_address_application_details:
      "Il n'y a pas de demande d'adresse de retrait.",
    kyc_authentication: 'Authentification KYC',
    kyc_application_details: "Détails de l'application KYC",
    security_level: 'Niveau de sécurité',
    view_rating: 'Voir la note',
    no_account_alias: '(Compte Surnom aucun)',
    no_choice: '(Pas le choix)',
    select_coin_to_exchange: 'sélectionnez la pièce à échanger',
    sending_verification_email: "Envoi d'un e-mail de vérification",
    sending_verification_email_txt:
      'Cliquez sur Envoyer un e-mail de vérification.',
    enter_verification_code: 'Authentifier',
    enter_verification_code_txt:
      "Entrez le code de vérification S'il vous plait.",
    verification_email_has_been_sent: 'Un e-mail de vérification a été envoyé.',
    base_asset_account_information:
      "Informations sur le compte d'actif de base",
    classification_of_transactions: 'Classification des transactions',
    logged_out_txt: 'Vous êtes déconnecté.',
    check_logged_out_txt: 'Voulez-vous vous déconnecter',
    scan_qr_code_txt: 'Veuillez scanner le code QR ci-dessous.',
    simple_login: 'Connexion simple',
    simple_login_txt: 'Entrez le code de vérification de connexion simple.',
    be_loggin_in: 'Vous vous connectez.',
    be_logged_in: 'Vous êtes connecté.',
    step_one: 'Étape 1',
    step_one_txt:
      "Veuillez installer Google OTP depuis l'App Store pour l'authentification OTP.",
    step_two: 'Étape 2',
    step_two_txt:
      'Veuillez imprimer ou noter le code à 16 chiffres émis. Ce code est utilisé pour la récupération en cas de perte / remplacement ou de suppression du téléphone mobile.',
    step_three: 'Étape 3',
    step_three_txt:
      "Scannez le code QR ci-dessous avec l'application Google Authenticaror installée.",
    step_four: 'Étape 4',
    step_four_txt:
      'Entrez le code de vérification OTP à 6 chiffres généré et cliquez sur Authentifier.',
    mobile_authentication: 'Authentification de téléphone mobile',
    mobile_authentication_txt:
      "L'authentification est effectuée à l'aide d'un téléphone mobile au nom de la personne.",
    do_mobile_authentication: 'Authentification du téléphone',
    complete_mobile_authentication: "L'authentification est terminée",
    failed_mobile_authentication: 'Authentification échouée.',
    transfer_quantity: 'Quantité de transfert',
    enter_transfer_quantity: 'Veuillez saisir la quantité de transfert.',
    transfer_quantity_2: 'Quantité de transfert',
    enter_transfer_quantity_2: 'Veuillez saisir la quantité de transfert.',
    select_transfer_quantity: 'Veuillez sélectionner la quantité de transfert.',
    enter_transfer_account_number:
      'Veuillez saisir le numéro de compte de transfert.',
    current_security_level: 'Votre niveau de sécurité actuel',
    choose_how_to_pay_the_fee: 'Choisissez comment payer les frais',
    confirm_withdrawal_application_information:
      'Confirmer les informations de demande de retrait',
    enter_login_code_txt:
      "Veuillez lire le code QR pour une vérification de connexion simple affiché sur l'écran du terminal <br/> dans le lecteur de code-barres ci-dessous, ou entrez le code de vérification simple dans le champ ci-dessous.",
    direct_ex_manual: 'Comment utiliser un échange de devises directe',
    deposit_transfer_manual: 'Comment utiliser les envois de dépôt',
    deposit_inquiry_txt_manual: 'Comment utiliser les requêtes de dépôt',
    deposit_withdrawal_manual: 'Comment utiliser le retrait de dépôt',
    wallet_transfer_manual: 'Comment utiliser le transfert de portefeuille',
    buy_with_coin_selected_account:
      'Acheter avec {code} à partir du compte sélectionné',
    sell_with_coin_selected_account: 'Vendez {code} sur le compte sélectionné.',
    receive_purchased_coin:
      'Veuillez sélectionner un compte pour recevoir le {code} acheté..',
    receive_converted_coin:
      'Veuillez sélectionner un compte pour recevoir le {code} converti.',
    enter_account_holder: 'Veuillez saisir le nom du titulaire du compte.',
    enter_account: 'Veuillez saisir votre numéro de compte.',
    enter_withdrawal: 'Veuillez saisir le montant du retrait.',
    transfer_to_another_wallet: 'Transférer vers un autre portefeuille',
    invalid_login_code: "Code d'authentification de connexion non valide.",
    payment_canceled: 'Le paiement a été annulé',
  },

  market_balance: {
    deposit_successful: 'Le dépôt a réussi.',
    wthdrawal_successful: 'Le retrait a réussi.',
    deposit: 'Dépôt',
    withdrawal: 'Retrait',
    select_account: 'Sélectionnez un compte',
    assets: 'Les atouts',
    select_market: 'Sélection de marché',
    quantity: 'Quantity',
    confirm: 'Confirmer',
  },
  pop_notice: {
    notice_close: 'fechar',
    notice_today: 'Não vendo hoje',
  },
  private_notice: {
    msg_false_deal_title: 'Elle interdit les fausses informations',
    msg_false_deal_content_1:
      "Les vendeurs doivent avoir un mot de passe, s'il vous plaît poster la devise de transaction nécessaire pour assez de vente.",
    msg_false_deal_content_2:
      "Les restrictions imposées sur l'utilisation des services de la ville ont continué à mener une fausse divulgation, s'il vous plaît noter que les bagages.",
    msg_deal_confirm_click_title: "Confirmé au clic d'un bouton Notes",
    msg_deal_confirm_click_content_1:
      "Le vendeur, bouton A vous de cliquer sur « confirmer », alors assurez-vous de vérifier le paiement de l'acheteur.",
    msg_deal_confirm_click_content_2:
      'Les banques Coco ne sont pas légalement responsable des dommages et intérêts causés par la négligence du vendeur. Assurez-vous de vérifier si les acheteurs de payer.',
    msg_deal_confirm_not_click_title:
      "Lorsqu'ils ne sont pas appuyé sur le bouton de confirmation",
    msg_deal_confirm_not_click_content_1:
      "Le vendeur paie la confirmation de l'acheteur que vous devez cliquer sur le bouton « Confirmer ».",
    msg_deal_confirm_not_click_content_2:
      "Les restrictions imposées sur les services utilisés par le gestionnaire quand n'a pas cliqué sur le bouton « confirmer » S'il vous plaît bagages note.",
    msg_c2c_title: 'transactions C2C',
    msg_c2c_content_1:
      "les transactions C2C sont basées sur les activités de libre-échange du vendeur et de l'acheteur.",
    msg_c2c_content_2:
      'La banque Coco ne fournit que des services de plate-forme pour les transactions sécurisées et pratiques pour les vendeurs et les acheteurs.',
    msg_c2c_content_3:
      "Coco banques se sont produits au cours du conflit juridique entre le vendeur et l'acheteur, s'il vous plaît noter que seul un rôle responsable en mains tierces.",
    msg_false_hold_title: "La fausse tenue d'interdire",
    msg_false_hold_content_1:
      "L'acheteur doit être sûr de cliquer sur le « hold » après paiement effectué pour le commerce C2C.",
    msg_false_hold_content_2:
      "Tout différend entre le vendeur et l'acheteur découlant de la tenue n'est pas responsable d'une banque Coco frauduleuse.",
    msg_false_hold_content_3:
      "Cette restriction a également appliquée à l'utilisation des services municipaux continuent d'effectuer la tenue fausse S'il vous plaît noter que les bagages.",
    msg_false_hold_content_4:
      "S'il n'y a pas de confirmation après avoir effectué votre paiement, s'il vous plaît contacter l'administrateur a par un sur un contact.",
    msg_false_hold_content_5:
      "Lorsque les transactions C2C via le porte-monnaie externe au cas où vous pouvez être payer des frais qu'elle n'a pas effectué correctement les transactions C2C peuvent être peu pratique pour les transactions réglées.",
  },
  kiosk_re: {
    choice_lang: 'Choisir la langue',
    buy_immedi:
      'Si vous utilisez Coco Bank, vous pouvez acheter<br><span> immédiatement avec </span>.',
    new_acc: 'Création de compte bancaire Coco',
    join_txt:
      "Lorsque vous utilisez un compte externe et un compte, vous devez effectuer une réservation d'achat, mais vous devez vérifier le vendeur, mais vous pouvez l'acheter immédiatement à l'aide de la banque COCO. Nous ne recevons pas de frais sur la banque Coco et nous appuyons le mouvement entre les actifs de mot de passe les plus rapides du monde.",
    main_order_txt:
      "Carte de crédit / achat du magasin d'actifs de mot de passe",
    main_bank_txt: 'Actifs de mot de passe Sûr Stockage et achat / vente',
    main_market_txt: 'Mot de passe en ligne Actifs Open Market',
    main_about: 'Coinabout',
    main_about_txt:
      'Nouvelles professionnelles pour les actifs de mot de passe',
    about_drw_txt_1:
      'Recevez rapidement et divers blocs de nouvelles de <span> Coinabout </span>.',
    about_drw_txt_2:
      'COINEA Boute fournit des nouvelles rapides et une analyse pour bloquer les t-shirts de la chaîne et des broches.',
    about_drw_txt_3:
      'Lorsque vous numérisez le code QR, la coinea est connectée au nez.',
    market_drw_txt_1: 'Maintenant, achats avec <span> actifs virtuels</span>.',
    market_drw_txt_2:
      "Notre marché Coco est un marché ouvert qui vous permet d'acheter des biens avec le premier atout virtuel en Corée.",
    market_drw_txt_3:
      'Lorsque vous numérisez le code QR, il sera connecté au marché COCO.',
    market_drw_txt_4:
      'Les marchés Coco construiront ensuite beaucoup de produits et divers actifs virtuels Systèmes de paiement.',
    login_title: 'Scannez le code <span>QR</span> ci-dessous.',
    login_txt_1:
      "Les informations de l'utilisateur sont requises pour une utilisation.",
    login_txt_2:
      "Veuillez entrer le code d'authentification de connexion simple affiché sur l'écran du terminal dans le champ ci-dessous.",
    code_txt:
      "Connexion simple<br><span>Entrez le code d'authentification</span>.",
    new_acc_tit_1: 'Créer un nouveau compte',
    new_acc_tit_2:
      'Veuillez vérifier le contenu nécessaire à la création de nouveaux comptes.',
    new_acc_txt_1:
      'Hangha pour la prévention des télécommunications fraude financière',
    new_acc_txt_2:
      "* Pour vous assurer que vous êtes plus facile à effectuer votre transfert vers Internet Banking, vous devrez être une authentification sécurisée. Après le processus de certification, veuillez améliorer la notation et poursuivre la comptabilité et l'arrangement du système de comptabilité.",
    new_acc_txt_3:
      "Si vous transférez sur votre compte à partir d'un compte Coco Bank dédié à votre compte, vous ne pourrez pas payer. Les comptes / adresses émises par de nouvelles entrées peuvent être déposées uniquement avec {0}. Erreur / perte pouvant survenir si vous essayez de déposer différents actifs numériques avec cette adresse n'est pas récupérable. Une fois qu'une confirmation se produit, elle est reflétée dans la balance à travers le processus de dépôt. Le processus de dépôt se déroulera automatiquement et le temps requis dépend de la situation du réseau. L'adresse ci-dessus est une adresse dédiée au dépôt.",
    new_acc_txt_4:
      'Vous pouvez déposer {0} comme nouvel abonnement attribué à votre adhésion.',
    new_acc_btn_agr: "consentement d'ouverture et compte",
    new_acc_txt_5: 'Le nouveau compte a été ouvert.',
    new_acc_txt_6:
      'Vous pouvez utiliser les services bancaires COCO sur un compte établi.',
    charge_tit_1: 'Chargez votre {0}.',
    charge_tit_2: 'Veuillez sélectionner un actif à utiliser pour charger {0}.',
    charge_tit_3:
      "S'il vous plaît accéder à votre compte et entrez la quantité d'actifs à utiliser pour la charge.",
    charge_txt_1: 'Taux de référence de charge',
    charge_txt_2: 'Type de charge',
    charge_txt_3: 'quantité standard',
    charge_txt_4: 'Capacité de charge',
    charge_txt_5: 'Mise en charge',
    charge_txt_6: 'La charge est complète.',
    charge_txt_7: "Au bout de 3 secondes pour revenir à l'écran principal.",
    complete: "Sélectionnez l'achèvement",
    input_complete: "Achèvement d'entrée",
    quan_max: 'maximum',
    buy_reserv: "Signé une réservation d'achat",
    krw_dialog_tit:
      'Veuillez cliquer sur le bouton de réservation de planification après le dépôt.',
    krw_dialog_txt_1:
      "Lorsque vous cliquez sur la réservation de pré-achat, votre portefeuille et vos comptes sont gelés et que l'acheteur clique enfin sur le montant des achats au vendeur, et le vendeur informera le vendeur et le vendeur sera en mesure d'acheter l'achat. Les actifs que vous avez achetés seront déposés.",
    krw_dialog_txt_2:
      "* Si le dépôt n'est pas fixé dans l'achat en 3 heures, un portefeuille et un compte congélateur seront disponibles. Toutefois, si le paiement n'est pas reçu le dépôt dans les 2-1 heures, veuillez nous contacter.",
    krw_dialog_txt_3:
      "L'acheteur réserve uniquement des réserves et si le dépôt n'est pas plus de trois fois, l'ID est arrêté.",
    purchase: 'Acheter des actifs',
    payable: 'Actifs de paiement',
    purchase_choice: 'Sélectionnez Acheter Asset',
    payable_choice: 'Sélectionnez Actifs de paiement',
    latest_order: 'Dernier',
    low_price: 'Bas prix',
    high_price: 'Prix ​​élevé',
    seller: 'vendeur',
    search_seller: 'Rechercher le vendeur.',
    no_regist: "Il n'y a pas de produit de vente enregistré.",
    other_seller: "Veuillez rechercher d'autres vendeurs.",
    pur_quan: 'Achat de quantité',
    buy_quan: 'Quantité de paiement',
    bank_txt_1:
      "Vous pouvez afficher la liste d'achat lorsque <span class = 'color-blue'> actifs d'achat </span> et <span class = 'color-green'> actif de paiement </span>.",
    sale_regist: 'Enregistrez votre divulgation de vente',
    bank_drw_tit: 'Enregistrement de la divulgation des ventes',
    bank_drw_txt_1:
      "L'enregistrement de la divulgation des ventes peut être enregistré sur mobile.",
    bank_drw_txt_2:
      "Lorsque vous numérisez le code QR, vous serez lié à la page d'enregistrement de la divulgation de vente.",
    total_charge: 'Quantité finale',
    detail_tit:
      "<strong> Veuillez vérifier les informations d'achat </strong>.",
    detail_sub:
      "Vous avez besoin d'un compte pour votre achat. Veuillez sélectionner.",
    pur_assets: 'Acheter des actifs',
    acc_receive: 'Sélectionnez un compte à recevoir',
    seller_acc_info: 'Informations sur le compte du vendeur',
    krw_txt: 'Coco Bank ne dépose pas ou sauvegarde KRW (gagné).',
    total_payble: 'Actifs de paiement final',
    purch_reser: 'Achat de réservation',
    buy: 'Acheter',
    buy_suc: "L'achat est complet.",
  },
}
